import jr, { useMemo as xi } from "react";
var D = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function wi(r) {
  if (r.__esModule) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function u() {
      return this instanceof u ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(u) {
    var n = Object.getOwnPropertyDescriptor(r, u);
    Object.defineProperty(t, u, n.get ? n : {
      enumerable: !0,
      get: function() {
        return r[u];
      }
    });
  }), t;
}
var au = { exports: {} }, Me = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Kt, nr;
function qr() {
  if (nr) return Kt;
  nr = 1;
  var r = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function u(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, l = 0; l < 10; l++)
        o["_" + String.fromCharCode(l)] = l;
      var a = Object.getOwnPropertyNames(o).map(function(h) {
        return o[h];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        f[h] = h;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Kt = n() ? Object.assign : function(i, o) {
    for (var l, a = u(i), f, h = 1; h < arguments.length; h++) {
      l = Object(arguments[h]);
      for (var y in l)
        e.call(l, y) && (a[y] = l[y]);
      if (r) {
        f = r(l);
        for (var s = 0; s < f.length; s++)
          t.call(l, f[s]) && (a[f[s]] = l[f[s]]);
      }
    }
    return a;
  }, Kt;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ir;
function Ei() {
  if (ir) return Me;
  ir = 1, qr();
  var r = jr, e = 60103;
  if (Me.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    e = t("react.element"), Me.Fragment = t("react.fragment");
  }
  var u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, a, f) {
    var h, y = {}, s = null, c = null;
    f !== void 0 && (s = "" + f), a.key !== void 0 && (s = "" + a.key), a.ref !== void 0 && (c = a.ref);
    for (h in a) n.call(a, h) && !i.hasOwnProperty(h) && (y[h] = a[h]);
    if (l && l.defaultProps) for (h in a = l.defaultProps, a) y[h] === void 0 && (y[h] = a[h]);
    return { $$typeof: e, type: l, key: s, ref: c, props: y, _owner: u.current };
  }
  return Me.jsx = o, Me.jsxs = o, Me;
}
var eu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ar;
function Si() {
  return ar || (ar = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      var e = jr, t = qr(), u = 60103, n = 60106;
      r.Fragment = 60107;
      var i = 60108, o = 60114, l = 60109, a = 60110, f = 60112, h = 60113, y = 60120, s = 60115, c = 60116, E = 60121, _ = 60122, m = 60117, T = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var N = Symbol.for;
        u = N("react.element"), n = N("react.portal"), r.Fragment = N("react.fragment"), i = N("react.strict_mode"), o = N("react.profiler"), l = N("react.provider"), a = N("react.context"), f = N("react.forward_ref"), h = N("react.suspense"), y = N("react.suspense_list"), s = N("react.memo"), c = N("react.lazy"), E = N("react.block"), _ = N("react.server.block"), m = N("react.fundamental"), N("react.scope"), N("react.opaque.id"), T = N("react.debug_trace_mode"), N("react.offscreen"), P = N("react.legacy_hidden");
      }
      var R = typeof Symbol == "function" && Symbol.iterator, F = "@@iterator";
      function K(d) {
        if (d === null || typeof d != "object")
          return null;
        var v = R && d[R] || d[F];
        return typeof v == "function" ? v : null;
      }
      var Q = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function k(d) {
        {
          for (var v = arguments.length, O = new Array(v > 1 ? v - 1 : 0), L = 1; L < v; L++)
            O[L - 1] = arguments[L];
          ue("error", d, O);
        }
      }
      function ue(d, v, O) {
        {
          var L = Q.ReactDebugCurrentFrame, X = L.getStackAddendum();
          X !== "" && (v += "%s", O = O.concat([X]));
          var Y = O.map(function(U) {
            return "" + U;
          });
          Y.unshift("Warning: " + v), Function.prototype.apply.call(console[d], console, Y);
        }
      }
      var Z = !1;
      function b(d) {
        return !!(typeof d == "string" || typeof d == "function" || d === r.Fragment || d === o || d === T || d === i || d === h || d === y || d === P || Z || typeof d == "object" && d !== null && (d.$$typeof === c || d.$$typeof === s || d.$$typeof === l || d.$$typeof === a || d.$$typeof === f || d.$$typeof === m || d.$$typeof === E || d[0] === _));
      }
      function w(d, v, O) {
        var L = v.displayName || v.name || "";
        return d.displayName || (L !== "" ? O + "(" + L + ")" : O);
      }
      function S(d) {
        return d.displayName || "Context";
      }
      function I(d) {
        if (d == null)
          return null;
        if (typeof d.tag == "number" && k("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof d == "function")
          return d.displayName || d.name || null;
        if (typeof d == "string")
          return d;
        switch (d) {
          case r.Fragment:
            return "Fragment";
          case n:
            return "Portal";
          case o:
            return "Profiler";
          case i:
            return "StrictMode";
          case h:
            return "Suspense";
          case y:
            return "SuspenseList";
        }
        if (typeof d == "object")
          switch (d.$$typeof) {
            case a:
              var v = d;
              return S(v) + ".Consumer";
            case l:
              var O = d;
              return S(O._context) + ".Provider";
            case f:
              return w(d, d.render, "ForwardRef");
            case s:
              return I(d.type);
            case E:
              return I(d._render);
            case c: {
              var L = d, X = L._payload, Y = L._init;
              try {
                return I(Y(X));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var p = 0, x, g, C, G, J, Re, Wt;
      function V() {
      }
      V.__reactDisabledLog = !0;
      function H() {
        {
          if (p === 0) {
            x = console.log, g = console.info, C = console.warn, G = console.error, J = console.group, Re = console.groupCollapsed, Wt = console.groupEnd;
            var d = {
              configurable: !0,
              enumerable: !0,
              value: V,
              writable: !0
            };
            Object.defineProperties(console, {
              info: d,
              log: d,
              warn: d,
              error: d,
              group: d,
              groupCollapsed: d,
              groupEnd: d
            });
          }
          p++;
        }
      }
      function Ge() {
        {
          if (p--, p === 0) {
            var d = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, d, {
                value: x
              }),
              info: t({}, d, {
                value: g
              }),
              warn: t({}, d, {
                value: C
              }),
              error: t({}, d, {
                value: G
              }),
              group: t({}, d, {
                value: J
              }),
              groupCollapsed: t({}, d, {
                value: Re
              }),
              groupEnd: t({}, d, {
                value: Wt
              })
            });
          }
          p < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var B = Q.ReactCurrentDispatcher, $;
      function oe(d, v, O) {
        {
          if ($ === void 0)
            try {
              throw Error();
            } catch (X) {
              var L = X.stack.trim().match(/\n( *(at )?)/);
              $ = L && L[1] || "";
            }
          return `
` + $ + d;
        }
      }
      var se = !1, re;
      {
        var Yt = typeof WeakMap == "function" ? WeakMap : Map;
        re = new Yt();
      }
      function We(d, v) {
        if (!d || se)
          return "";
        {
          var O = re.get(d);
          if (O !== void 0)
            return O;
        }
        var L;
        se = !0;
        var X = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Y;
        Y = B.current, B.current = null, H();
        try {
          if (v) {
            var U = function() {
              throw Error();
            };
            if (Object.defineProperty(U.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(U, []);
              } catch (be) {
                L = be;
              }
              Reflect.construct(d, [], U);
            } else {
              try {
                U.call();
              } catch (be) {
                L = be;
              }
              d.call(U.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (be) {
              L = be;
            }
            d();
          }
        } catch (be) {
          if (be && L && typeof be.stack == "string") {
            for (var q = be.stack.split(`
`), ne = L.stack.split(`
`), ee = q.length - 1, te = ne.length - 1; ee >= 1 && te >= 0 && q[ee] !== ne[te]; )
              te--;
            for (; ee >= 1 && te >= 0; ee--, te--)
              if (q[ee] !== ne[te]) {
                if (ee !== 1 || te !== 1)
                  do
                    if (ee--, te--, te < 0 || q[ee] !== ne[te]) {
                      var pe = `
` + q[ee].replace(" at new ", " at ");
                      return typeof d == "function" && re.set(d, pe), pe;
                    }
                  while (ee >= 1 && te >= 0);
                break;
              }
          }
        } finally {
          se = !1, B.current = Y, Ge(), Error.prepareStackTrace = X;
        }
        var Le = d ? d.displayName || d.name : "", rr = Le ? oe(Le) : "";
        return typeof d == "function" && re.set(d, rr), rr;
      }
      function ht(d, v, O) {
        return We(d, !1);
      }
      function ti(d) {
        var v = d.prototype;
        return !!(v && v.isReactComponent);
      }
      function pt(d, v, O) {
        if (d == null)
          return "";
        if (typeof d == "function")
          return We(d, ti(d));
        if (typeof d == "string")
          return oe(d);
        switch (d) {
          case h:
            return oe("Suspense");
          case y:
            return oe("SuspenseList");
        }
        if (typeof d == "object")
          switch (d.$$typeof) {
            case f:
              return ht(d.render);
            case s:
              return pt(d.type, v, O);
            case E:
              return ht(d._render);
            case c: {
              var L = d, X = L._payload, Y = L._init;
              try {
                return pt(Y(X), v, O);
              } catch {
              }
            }
          }
        return "";
      }
      var Gu = {}, Wu = Q.ReactDebugCurrentFrame;
      function bt(d) {
        if (d) {
          var v = d._owner, O = pt(d.type, d._source, v ? v.type : null);
          Wu.setExtraStackFrame(O);
        } else
          Wu.setExtraStackFrame(null);
      }
      function ui(d, v, O, L, X) {
        {
          var Y = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var U in d)
            if (Y(d, U)) {
              var q = void 0;
              try {
                if (typeof d[U] != "function") {
                  var ne = Error((L || "React class") + ": " + O + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ne.name = "Invariant Violation", ne;
                }
                q = d[U](v, U, L, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ee) {
                q = ee;
              }
              q && !(q instanceof Error) && (bt(X), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", L || "React class", O, U, typeof q), bt(null)), q instanceof Error && !(q.message in Gu) && (Gu[q.message] = !0, bt(X), k("Failed %s type: %s", O, q.message), bt(null));
            }
        }
      }
      var Yu = Q.ReactCurrentOwner, Xt = Object.prototype.hasOwnProperty, ri = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Xu, Ju;
      function ni(d) {
        if (Xt.call(d, "ref")) {
          var v = Object.getOwnPropertyDescriptor(d, "ref").get;
          if (v && v.isReactWarning)
            return !1;
        }
        return d.ref !== void 0;
      }
      function ii(d) {
        if (Xt.call(d, "key")) {
          var v = Object.getOwnPropertyDescriptor(d, "key").get;
          if (v && v.isReactWarning)
            return !1;
        }
        return d.key !== void 0;
      }
      function ai(d, v) {
        typeof d.ref == "string" && Yu.current;
      }
      function si(d, v) {
        {
          var O = function() {
            Xu || (Xu = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
          };
          O.isReactWarning = !0, Object.defineProperty(d, "key", {
            get: O,
            configurable: !0
          });
        }
      }
      function oi(d, v) {
        {
          var O = function() {
            Ju || (Ju = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
          };
          O.isReactWarning = !0, Object.defineProperty(d, "ref", {
            get: O,
            configurable: !0
          });
        }
      }
      var ci = function(d, v, O, L, X, Y, U) {
        var q = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: u,
          // Built-in properties that belong on the element
          type: d,
          key: v,
          ref: O,
          props: U,
          // Record the component responsible for creating this element.
          _owner: Y
        };
        return q._store = {}, Object.defineProperty(q._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(q, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: L
        }), Object.defineProperty(q, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: X
        }), Object.freeze && (Object.freeze(q.props), Object.freeze(q)), q;
      };
      function li(d, v, O, L, X) {
        {
          var Y, U = {}, q = null, ne = null;
          O !== void 0 && (q = "" + O), ii(v) && (q = "" + v.key), ni(v) && (ne = v.ref, ai(v, X));
          for (Y in v)
            Xt.call(v, Y) && !ri.hasOwnProperty(Y) && (U[Y] = v[Y]);
          if (d && d.defaultProps) {
            var ee = d.defaultProps;
            for (Y in ee)
              U[Y] === void 0 && (U[Y] = ee[Y]);
          }
          if (q || ne) {
            var te = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
            q && si(U, te), ne && oi(U, te);
          }
          return ci(d, q, ne, X, L, Yu.current, U);
        }
      }
      var Jt = Q.ReactCurrentOwner, Zu = Q.ReactDebugCurrentFrame;
      function De(d) {
        if (d) {
          var v = d._owner, O = pt(d.type, d._source, v ? v.type : null);
          Zu.setExtraStackFrame(O);
        } else
          Zu.setExtraStackFrame(null);
      }
      var Zt;
      Zt = !1;
      function Qt(d) {
        return typeof d == "object" && d !== null && d.$$typeof === u;
      }
      function Qu() {
        {
          if (Jt.current) {
            var d = I(Jt.current.type);
            if (d)
              return `

Check the render method of \`` + d + "`.";
          }
          return "";
        }
      }
      function fi(d) {
        return "";
      }
      var Ku = {};
      function di(d) {
        {
          var v = Qu();
          if (!v) {
            var O = typeof d == "string" ? d : d.displayName || d.name;
            O && (v = `

Check the top-level render call using <` + O + ">.");
          }
          return v;
        }
      }
      function er(d, v) {
        {
          if (!d._store || d._store.validated || d.key != null)
            return;
          d._store.validated = !0;
          var O = di(v);
          if (Ku[O])
            return;
          Ku[O] = !0;
          var L = "";
          d && d._owner && d._owner !== Jt.current && (L = " It was passed a child from " + I(d._owner.type) + "."), De(d), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, L), De(null);
        }
      }
      function tr(d, v) {
        {
          if (typeof d != "object")
            return;
          if (Array.isArray(d))
            for (var O = 0; O < d.length; O++) {
              var L = d[O];
              Qt(L) && er(L, v);
            }
          else if (Qt(d))
            d._store && (d._store.validated = !0);
          else if (d) {
            var X = K(d);
            if (typeof X == "function" && X !== d.entries)
              for (var Y = X.call(d), U; !(U = Y.next()).done; )
                Qt(U.value) && er(U.value, v);
          }
        }
      }
      function hi(d) {
        {
          var v = d.type;
          if (v == null || typeof v == "string")
            return;
          var O;
          if (typeof v == "function")
            O = v.propTypes;
          else if (typeof v == "object" && (v.$$typeof === f || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          v.$$typeof === s))
            O = v.propTypes;
          else
            return;
          if (O) {
            var L = I(v);
            ui(O, d.props, "prop", L, d);
          } else if (v.PropTypes !== void 0 && !Zt) {
            Zt = !0;
            var X = I(v);
            k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", X || "Unknown");
          }
          typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function pi(d) {
        {
          for (var v = Object.keys(d.props), O = 0; O < v.length; O++) {
            var L = v[O];
            if (L !== "children" && L !== "key") {
              De(d), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", L), De(null);
              break;
            }
          }
          d.ref !== null && (De(d), k("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
        }
      }
      function ur(d, v, O, L, X, Y) {
        {
          var U = b(d);
          if (!U) {
            var q = "";
            (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ne = fi();
            ne ? q += ne : q += Qu();
            var ee;
            d === null ? ee = "null" : Array.isArray(d) ? ee = "array" : d !== void 0 && d.$$typeof === u ? (ee = "<" + (I(d.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : ee = typeof d, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ee, q);
          }
          var te = li(d, v, O, X, Y);
          if (te == null)
            return te;
          if (U) {
            var pe = v.children;
            if (pe !== void 0)
              if (L)
                if (Array.isArray(pe)) {
                  for (var Le = 0; Le < pe.length; Le++)
                    tr(pe[Le], d);
                  Object.freeze && Object.freeze(pe);
                } else
                  k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                tr(pe, d);
          }
          return d === r.Fragment ? pi(te) : hi(te), te;
        }
      }
      function bi(d, v, O) {
        return ur(d, v, O, !0);
      }
      function mi(d, v, O) {
        return ur(d, v, O, !1);
      }
      var gi = mi, yi = bi;
      r.jsx = gi, r.jsxs = yi;
    }();
  }(eu)), eu;
}
process.env.NODE_ENV === "production" ? au.exports = Ei() : au.exports = Si();
var A = au.exports, Br = {}, Ke = {}, Au = {}, et = {}, _u = {};
Object.defineProperty(_u, "__esModule", { value: !0 });
_u.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var Ou = {};
Object.defineProperty(Ou, "__esModule", { value: !0 });
Ou.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var su = {};
(function(r) {
  var e;
  Object.defineProperty(r, "__esModule", { value: !0 }), r.replaceCodePoint = r.fromCodePoint = void 0;
  var t = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  r.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(i) {
    var o = "";
    return i > 65535 && (i -= 65536, o += String.fromCharCode(i >>> 10 & 1023 | 55296), i = 56320 | i & 1023), o += String.fromCharCode(i), o;
  };
  function u(i) {
    var o;
    return i >= 55296 && i <= 57343 || i > 1114111 ? 65533 : (o = t.get(i)) !== null && o !== void 0 ? o : i;
  }
  r.replaceCodePoint = u;
  function n(i) {
    return (0, r.fromCodePoint)(u(i));
  }
  r.default = n;
})(su);
(function(r) {
  var e = D && D.__createBinding || (Object.create ? function(b, w, S, I) {
    I === void 0 && (I = S);
    var p = Object.getOwnPropertyDescriptor(w, S);
    (!p || ("get" in p ? !w.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return w[S];
    } }), Object.defineProperty(b, I, p);
  } : function(b, w, S, I) {
    I === void 0 && (I = S), b[I] = w[S];
  }), t = D && D.__setModuleDefault || (Object.create ? function(b, w) {
    Object.defineProperty(b, "default", { enumerable: !0, value: w });
  } : function(b, w) {
    b.default = w;
  }), u = D && D.__importStar || function(b) {
    if (b && b.__esModule) return b;
    var w = {};
    if (b != null) for (var S in b) S !== "default" && Object.prototype.hasOwnProperty.call(b, S) && e(w, b, S);
    return t(w, b), w;
  }, n = D && D.__importDefault || function(b) {
    return b && b.__esModule ? b : { default: b };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXML = r.decodeHTMLStrict = r.decodeHTMLAttribute = r.decodeHTML = r.determineBranch = r.EntityDecoder = r.DecodingMode = r.BinTrieFlags = r.fromCodePoint = r.replaceCodePoint = r.decodeCodePoint = r.xmlDecodeTree = r.htmlDecodeTree = void 0;
  var i = n(_u);
  r.htmlDecodeTree = i.default;
  var o = n(Ou);
  r.xmlDecodeTree = o.default;
  var l = u(su);
  r.decodeCodePoint = l.default;
  var a = su;
  Object.defineProperty(r, "replaceCodePoint", { enumerable: !0, get: function() {
    return a.replaceCodePoint;
  } }), Object.defineProperty(r, "fromCodePoint", { enumerable: !0, get: function() {
    return a.fromCodePoint;
  } });
  var f;
  (function(b) {
    b[b.NUM = 35] = "NUM", b[b.SEMI = 59] = "SEMI", b[b.EQUALS = 61] = "EQUALS", b[b.ZERO = 48] = "ZERO", b[b.NINE = 57] = "NINE", b[b.LOWER_A = 97] = "LOWER_A", b[b.LOWER_F = 102] = "LOWER_F", b[b.LOWER_X = 120] = "LOWER_X", b[b.LOWER_Z = 122] = "LOWER_Z", b[b.UPPER_A = 65] = "UPPER_A", b[b.UPPER_F = 70] = "UPPER_F", b[b.UPPER_Z = 90] = "UPPER_Z";
  })(f || (f = {}));
  var h = 32, y;
  (function(b) {
    b[b.VALUE_LENGTH = 49152] = "VALUE_LENGTH", b[b.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", b[b.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(y = r.BinTrieFlags || (r.BinTrieFlags = {}));
  function s(b) {
    return b >= f.ZERO && b <= f.NINE;
  }
  function c(b) {
    return b >= f.UPPER_A && b <= f.UPPER_F || b >= f.LOWER_A && b <= f.LOWER_F;
  }
  function E(b) {
    return b >= f.UPPER_A && b <= f.UPPER_Z || b >= f.LOWER_A && b <= f.LOWER_Z || s(b);
  }
  function _(b) {
    return b === f.EQUALS || E(b);
  }
  var m;
  (function(b) {
    b[b.EntityStart = 0] = "EntityStart", b[b.NumericStart = 1] = "NumericStart", b[b.NumericDecimal = 2] = "NumericDecimal", b[b.NumericHex = 3] = "NumericHex", b[b.NamedEntity = 4] = "NamedEntity";
  })(m || (m = {}));
  var T;
  (function(b) {
    b[b.Legacy = 0] = "Legacy", b[b.Strict = 1] = "Strict", b[b.Attribute = 2] = "Attribute";
  })(T = r.DecodingMode || (r.DecodingMode = {}));
  var P = (
    /** @class */
    function() {
      function b(w, S, I) {
        this.decodeTree = w, this.emitCodePoint = S, this.errors = I, this.state = m.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = T.Strict;
      }
      return b.prototype.startEntity = function(w) {
        this.decodeMode = w, this.state = m.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, b.prototype.write = function(w, S) {
        switch (this.state) {
          case m.EntityStart:
            return w.charCodeAt(S) === f.NUM ? (this.state = m.NumericStart, this.consumed += 1, this.stateNumericStart(w, S + 1)) : (this.state = m.NamedEntity, this.stateNamedEntity(w, S));
          case m.NumericStart:
            return this.stateNumericStart(w, S);
          case m.NumericDecimal:
            return this.stateNumericDecimal(w, S);
          case m.NumericHex:
            return this.stateNumericHex(w, S);
          case m.NamedEntity:
            return this.stateNamedEntity(w, S);
        }
      }, b.prototype.stateNumericStart = function(w, S) {
        return S >= w.length ? -1 : (w.charCodeAt(S) | h) === f.LOWER_X ? (this.state = m.NumericHex, this.consumed += 1, this.stateNumericHex(w, S + 1)) : (this.state = m.NumericDecimal, this.stateNumericDecimal(w, S));
      }, b.prototype.addToNumericResult = function(w, S, I, p) {
        if (S !== I) {
          var x = I - S;
          this.result = this.result * Math.pow(p, x) + parseInt(w.substr(S, x), p), this.consumed += x;
        }
      }, b.prototype.stateNumericHex = function(w, S) {
        for (var I = S; S < w.length; ) {
          var p = w.charCodeAt(S);
          if (s(p) || c(p))
            S += 1;
          else
            return this.addToNumericResult(w, I, S, 16), this.emitNumericEntity(p, 3);
        }
        return this.addToNumericResult(w, I, S, 16), -1;
      }, b.prototype.stateNumericDecimal = function(w, S) {
        for (var I = S; S < w.length; ) {
          var p = w.charCodeAt(S);
          if (s(p))
            S += 1;
          else
            return this.addToNumericResult(w, I, S, 10), this.emitNumericEntity(p, 2);
        }
        return this.addToNumericResult(w, I, S, 10), -1;
      }, b.prototype.emitNumericEntity = function(w, S) {
        var I;
        if (this.consumed <= S)
          return (I = this.errors) === null || I === void 0 || I.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (w === f.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === T.Strict)
          return 0;
        return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (w !== f.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, b.prototype.stateNamedEntity = function(w, S) {
        for (var I = this.decodeTree, p = I[this.treeIndex], x = (p & y.VALUE_LENGTH) >> 14; S < w.length; S++, this.excess++) {
          var g = w.charCodeAt(S);
          if (this.treeIndex = R(I, p, this.treeIndex + Math.max(1, x), g), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === T.Attribute && // We shouldn't have consumed any characters after the entity,
            (x === 0 || // And there should be no invalid characters.
            _(g)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (p = I[this.treeIndex], x = (p & y.VALUE_LENGTH) >> 14, x !== 0) {
            if (g === f.SEMI)
              return this.emitNamedEntityData(this.treeIndex, x, this.consumed + this.excess);
            this.decodeMode !== T.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, b.prototype.emitNotTerminatedNamedEntity = function() {
        var w, S = this, I = S.result, p = S.decodeTree, x = (p[I] & y.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(I, x, this.consumed), (w = this.errors) === null || w === void 0 || w.missingSemicolonAfterCharacterReference(), this.consumed;
      }, b.prototype.emitNamedEntityData = function(w, S, I) {
        var p = this.decodeTree;
        return this.emitCodePoint(S === 1 ? p[w] & ~y.VALUE_LENGTH : p[w + 1], I), S === 3 && this.emitCodePoint(p[w + 2], I), I;
      }, b.prototype.end = function() {
        var w;
        switch (this.state) {
          case m.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== T.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case m.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case m.NumericHex:
            return this.emitNumericEntity(0, 3);
          case m.NumericStart:
            return (w = this.errors) === null || w === void 0 || w.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case m.EntityStart:
            return 0;
        }
      }, b;
    }()
  );
  r.EntityDecoder = P;
  function N(b) {
    var w = "", S = new P(b, function(I) {
      return w += (0, l.fromCodePoint)(I);
    });
    return function(p, x) {
      for (var g = 0, C = 0; (C = p.indexOf("&", C)) >= 0; ) {
        w += p.slice(g, C), S.startEntity(x);
        var G = S.write(
          p,
          // Skip the "&"
          C + 1
        );
        if (G < 0) {
          g = C + S.end();
          break;
        }
        g = C + G, C = G === 0 ? g + 1 : g;
      }
      var J = w + p.slice(g);
      return w = "", J;
    };
  }
  function R(b, w, S, I) {
    var p = (w & y.BRANCH_LENGTH) >> 7, x = w & y.JUMP_TABLE;
    if (p === 0)
      return x !== 0 && I === x ? S : -1;
    if (x) {
      var g = I - x;
      return g < 0 || g >= p ? -1 : b[S + g] - 1;
    }
    for (var C = S, G = C + p - 1; C <= G; ) {
      var J = C + G >>> 1, Re = b[J];
      if (Re < I)
        C = J + 1;
      else if (Re > I)
        G = J - 1;
      else
        return b[J + p];
    }
    return -1;
  }
  r.determineBranch = R;
  var F = N(i.default), K = N(o.default);
  function Q(b, w) {
    return w === void 0 && (w = T.Legacy), F(b, w);
  }
  r.decodeHTML = Q;
  function k(b) {
    return F(b, T.Attribute);
  }
  r.decodeHTMLAttribute = k;
  function ue(b) {
    return F(b, T.Strict);
  }
  r.decodeHTMLStrict = ue;
  function Z(b) {
    return K(b, T.Strict);
  }
  r.decodeXML = Z;
})(et);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.QuoteType = void 0;
  var e = et, t;
  (function(s) {
    s[s.Tab = 9] = "Tab", s[s.NewLine = 10] = "NewLine", s[s.FormFeed = 12] = "FormFeed", s[s.CarriageReturn = 13] = "CarriageReturn", s[s.Space = 32] = "Space", s[s.ExclamationMark = 33] = "ExclamationMark", s[s.Number = 35] = "Number", s[s.Amp = 38] = "Amp", s[s.SingleQuote = 39] = "SingleQuote", s[s.DoubleQuote = 34] = "DoubleQuote", s[s.Dash = 45] = "Dash", s[s.Slash = 47] = "Slash", s[s.Zero = 48] = "Zero", s[s.Nine = 57] = "Nine", s[s.Semi = 59] = "Semi", s[s.Lt = 60] = "Lt", s[s.Eq = 61] = "Eq", s[s.Gt = 62] = "Gt", s[s.Questionmark = 63] = "Questionmark", s[s.UpperA = 65] = "UpperA", s[s.LowerA = 97] = "LowerA", s[s.UpperF = 70] = "UpperF", s[s.LowerF = 102] = "LowerF", s[s.UpperZ = 90] = "UpperZ", s[s.LowerZ = 122] = "LowerZ", s[s.LowerX = 120] = "LowerX", s[s.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(t || (t = {}));
  var u;
  (function(s) {
    s[s.Text = 1] = "Text", s[s.BeforeTagName = 2] = "BeforeTagName", s[s.InTagName = 3] = "InTagName", s[s.InSelfClosingTag = 4] = "InSelfClosingTag", s[s.BeforeClosingTagName = 5] = "BeforeClosingTagName", s[s.InClosingTagName = 6] = "InClosingTagName", s[s.AfterClosingTagName = 7] = "AfterClosingTagName", s[s.BeforeAttributeName = 8] = "BeforeAttributeName", s[s.InAttributeName = 9] = "InAttributeName", s[s.AfterAttributeName = 10] = "AfterAttributeName", s[s.BeforeAttributeValue = 11] = "BeforeAttributeValue", s[s.InAttributeValueDq = 12] = "InAttributeValueDq", s[s.InAttributeValueSq = 13] = "InAttributeValueSq", s[s.InAttributeValueNq = 14] = "InAttributeValueNq", s[s.BeforeDeclaration = 15] = "BeforeDeclaration", s[s.InDeclaration = 16] = "InDeclaration", s[s.InProcessingInstruction = 17] = "InProcessingInstruction", s[s.BeforeComment = 18] = "BeforeComment", s[s.CDATASequence = 19] = "CDATASequence", s[s.InSpecialComment = 20] = "InSpecialComment", s[s.InCommentLike = 21] = "InCommentLike", s[s.BeforeSpecialS = 22] = "BeforeSpecialS", s[s.SpecialStartSequence = 23] = "SpecialStartSequence", s[s.InSpecialTag = 24] = "InSpecialTag", s[s.BeforeEntity = 25] = "BeforeEntity", s[s.BeforeNumericEntity = 26] = "BeforeNumericEntity", s[s.InNamedEntity = 27] = "InNamedEntity", s[s.InNumericEntity = 28] = "InNumericEntity", s[s.InHexEntity = 29] = "InHexEntity";
  })(u || (u = {}));
  function n(s) {
    return s === t.Space || s === t.NewLine || s === t.Tab || s === t.FormFeed || s === t.CarriageReturn;
  }
  function i(s) {
    return s === t.Slash || s === t.Gt || n(s);
  }
  function o(s) {
    return s >= t.Zero && s <= t.Nine;
  }
  function l(s) {
    return s >= t.LowerA && s <= t.LowerZ || s >= t.UpperA && s <= t.UpperZ;
  }
  function a(s) {
    return s >= t.UpperA && s <= t.UpperF || s >= t.LowerA && s <= t.LowerF;
  }
  var f;
  (function(s) {
    s[s.NoValue = 0] = "NoValue", s[s.Unquoted = 1] = "Unquoted", s[s.Single = 2] = "Single", s[s.Double = 3] = "Double";
  })(f = r.QuoteType || (r.QuoteType = {}));
  var h = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, y = (
    /** @class */
    function() {
      function s(c, E) {
        var _ = c.xmlMode, m = _ === void 0 ? !1 : _, T = c.decodeEntities, P = T === void 0 ? !0 : T;
        this.cbs = E, this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = m, this.decodeEntities = P, this.entityTrie = m ? e.xmlDecodeTree : e.htmlDecodeTree;
      }
      return s.prototype.reset = function() {
        this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, s.prototype.write = function(c) {
        this.offset += this.buffer.length, this.buffer = c, this.parse();
      }, s.prototype.end = function() {
        this.running && this.finish();
      }, s.prototype.pause = function() {
        this.running = !1;
      }, s.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, s.prototype.getIndex = function() {
        return this.index;
      }, s.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, s.prototype.stateText = function(c) {
        c === t.Lt || !this.decodeEntities && this.fastForwardTo(t.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = u.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && c === t.Amp && (this.state = u.BeforeEntity);
      }, s.prototype.stateSpecialStartSequence = function(c) {
        var E = this.sequenceIndex === this.currentSequence.length, _ = E ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          i(c)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (c | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!_)
          this.isSpecial = !1;
        else if (!E) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = u.InTagName, this.stateInTagName(c);
      }, s.prototype.stateInSpecialTag = function(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (c === t.Gt || n(c)) {
            var E = this.index - this.currentSequence.length;
            if (this.sectionStart < E) {
              var _ = this.index;
              this.index = E, this.cbs.ontext(this.sectionStart, E), this.index = _;
            }
            this.isSpecial = !1, this.sectionStart = E + 2, this.stateInClosingTagName(c);
            return;
          }
          this.sequenceIndex = 0;
        }
        (c | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === h.TitleEnd ? this.decodeEntities && c === t.Amp && (this.state = u.BeforeEntity) : this.fastForwardTo(t.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(c === t.Lt);
      }, s.prototype.stateCDATASequence = function(c) {
        c === h.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === h.Cdata.length && (this.state = u.InCommentLike, this.currentSequence = h.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = u.InDeclaration, this.stateInDeclaration(c));
      }, s.prototype.fastForwardTo = function(c) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === c)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, s.prototype.stateInCommentLike = function(c) {
        c === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === h.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = u.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : c !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, s.prototype.isTagStartChar = function(c) {
        return this.xmlMode ? !i(c) : l(c);
      }, s.prototype.startSpecial = function(c, E) {
        this.isSpecial = !0, this.currentSequence = c, this.sequenceIndex = E, this.state = u.SpecialStartSequence;
      }, s.prototype.stateBeforeTagName = function(c) {
        if (c === t.ExclamationMark)
          this.state = u.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (c === t.Questionmark)
          this.state = u.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(c)) {
          var E = c | 32;
          this.sectionStart = this.index, !this.xmlMode && E === h.TitleEnd[2] ? this.startSpecial(h.TitleEnd, 3) : this.state = !this.xmlMode && E === h.ScriptEnd[2] ? u.BeforeSpecialS : u.InTagName;
        } else c === t.Slash ? this.state = u.BeforeClosingTagName : (this.state = u.Text, this.stateText(c));
      }, s.prototype.stateInTagName = function(c) {
        i(c) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c));
      }, s.prototype.stateBeforeClosingTagName = function(c) {
        n(c) || (c === t.Gt ? this.state = u.Text : (this.state = this.isTagStartChar(c) ? u.InClosingTagName : u.InSpecialComment, this.sectionStart = this.index));
      }, s.prototype.stateInClosingTagName = function(c) {
        (c === t.Gt || n(c)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterClosingTagName, this.stateAfterClosingTagName(c));
      }, s.prototype.stateAfterClosingTagName = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeAttributeName = function(c) {
        c === t.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = u.InSpecialTag, this.sequenceIndex = 0) : this.state = u.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : c === t.Slash ? this.state = u.InSelfClosingTag : n(c) || (this.state = u.InAttributeName, this.sectionStart = this.index);
      }, s.prototype.stateInSelfClosingTag = function(c) {
        c === t.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : n(c) || (this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c));
      }, s.prototype.stateInAttributeName = function(c) {
        (c === t.Eq || i(c)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterAttributeName, this.stateAfterAttributeName(c));
      }, s.prototype.stateAfterAttributeName = function(c) {
        c === t.Eq ? this.state = u.BeforeAttributeValue : c === t.Slash || c === t.Gt ? (this.cbs.onattribend(f.NoValue, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c)) : n(c) || (this.cbs.onattribend(f.NoValue, this.index), this.state = u.InAttributeName, this.sectionStart = this.index);
      }, s.prototype.stateBeforeAttributeValue = function(c) {
        c === t.DoubleQuote ? (this.state = u.InAttributeValueDq, this.sectionStart = this.index + 1) : c === t.SingleQuote ? (this.state = u.InAttributeValueSq, this.sectionStart = this.index + 1) : n(c) || (this.sectionStart = this.index, this.state = u.InAttributeValueNq, this.stateInAttributeValueNoQuotes(c));
      }, s.prototype.handleInAttributeValue = function(c, E) {
        c === E || !this.decodeEntities && this.fastForwardTo(E) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(E === t.DoubleQuote ? f.Double : f.Single, this.index), this.state = u.BeforeAttributeName) : this.decodeEntities && c === t.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, s.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, t.DoubleQuote);
      }, s.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, t.SingleQuote);
      }, s.prototype.stateInAttributeValueNoQuotes = function(c) {
        n(c) || c === t.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(f.Unquoted, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c)) : this.decodeEntities && c === t.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, s.prototype.stateBeforeDeclaration = function(c) {
        c === t.OpeningSquareBracket ? (this.state = u.CDATASequence, this.sequenceIndex = 0) : this.state = c === t.Dash ? u.BeforeComment : u.InDeclaration;
      }, s.prototype.stateInDeclaration = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateInProcessingInstruction = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeComment = function(c) {
        c === t.Dash ? (this.state = u.InCommentLike, this.currentSequence = h.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = u.InDeclaration;
      }, s.prototype.stateInSpecialComment = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeSpecialS = function(c) {
        var E = c | 32;
        E === h.ScriptEnd[3] ? this.startSpecial(h.ScriptEnd, 4) : E === h.StyleEnd[3] ? this.startSpecial(h.StyleEnd, 4) : (this.state = u.InTagName, this.stateInTagName(c));
      }, s.prototype.stateBeforeEntity = function(c) {
        this.entityExcess = 1, this.entityResult = 0, c === t.Number ? this.state = u.BeforeNumericEntity : c === t.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = u.InNamedEntity, this.stateInNamedEntity(c));
      }, s.prototype.stateInNamedEntity = function(c) {
        if (this.entityExcess += 1, this.trieIndex = (0, e.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var E = this.trieCurrent & e.BinTrieFlags.VALUE_LENGTH;
        if (E) {
          var _ = (E >> 14) - 1;
          if (!this.allowLegacyEntity() && c !== t.Semi)
            this.trieIndex += _;
          else {
            var m = this.index - this.entityExcess + 1;
            m > this.sectionStart && this.emitPartial(this.sectionStart, m), this.entityResult = this.trieIndex, this.trieIndex += _, this.entityExcess = 0, this.sectionStart = this.index + 1, _ === 0 && this.emitNamedEntity();
          }
        }
      }, s.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var c = (this.entityTrie[this.entityResult] & e.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (c) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~e.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, s.prototype.stateBeforeNumericEntity = function(c) {
        (c | 32) === t.LowerX ? (this.entityExcess++, this.state = u.InHexEntity) : (this.state = u.InNumericEntity, this.stateInNumericEntity(c));
      }, s.prototype.emitNumericEntity = function(c) {
        var E = this.index - this.entityExcess - 1, _ = E + 2 + +(this.state === u.InHexEntity);
        _ !== this.index && (E > this.sectionStart && this.emitPartial(this.sectionStart, E), this.sectionStart = this.index + Number(c), this.emitCodePoint((0, e.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, s.prototype.stateInNumericEntity = function(c) {
        c === t.Semi ? this.emitNumericEntity(!0) : o(c) ? (this.entityResult = this.entityResult * 10 + (c - t.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, s.prototype.stateInHexEntity = function(c) {
        c === t.Semi ? this.emitNumericEntity(!0) : o(c) ? (this.entityResult = this.entityResult * 16 + (c - t.Zero), this.entityExcess++) : a(c) ? (this.entityResult = this.entityResult * 16 + ((c | 32) - t.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, s.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === u.Text || this.baseState === u.InSpecialTag);
      }, s.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === u.Text || this.state === u.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === u.InAttributeValueDq || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, s.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, s.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var c = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case u.Text: {
              this.stateText(c);
              break;
            }
            case u.SpecialStartSequence: {
              this.stateSpecialStartSequence(c);
              break;
            }
            case u.InSpecialTag: {
              this.stateInSpecialTag(c);
              break;
            }
            case u.CDATASequence: {
              this.stateCDATASequence(c);
              break;
            }
            case u.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(c);
              break;
            }
            case u.InAttributeName: {
              this.stateInAttributeName(c);
              break;
            }
            case u.InCommentLike: {
              this.stateInCommentLike(c);
              break;
            }
            case u.InSpecialComment: {
              this.stateInSpecialComment(c);
              break;
            }
            case u.BeforeAttributeName: {
              this.stateBeforeAttributeName(c);
              break;
            }
            case u.InTagName: {
              this.stateInTagName(c);
              break;
            }
            case u.InClosingTagName: {
              this.stateInClosingTagName(c);
              break;
            }
            case u.BeforeTagName: {
              this.stateBeforeTagName(c);
              break;
            }
            case u.AfterAttributeName: {
              this.stateAfterAttributeName(c);
              break;
            }
            case u.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(c);
              break;
            }
            case u.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(c);
              break;
            }
            case u.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(c);
              break;
            }
            case u.AfterClosingTagName: {
              this.stateAfterClosingTagName(c);
              break;
            }
            case u.BeforeSpecialS: {
              this.stateBeforeSpecialS(c);
              break;
            }
            case u.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(c);
              break;
            }
            case u.InSelfClosingTag: {
              this.stateInSelfClosingTag(c);
              break;
            }
            case u.InDeclaration: {
              this.stateInDeclaration(c);
              break;
            }
            case u.BeforeDeclaration: {
              this.stateBeforeDeclaration(c);
              break;
            }
            case u.BeforeComment: {
              this.stateBeforeComment(c);
              break;
            }
            case u.InProcessingInstruction: {
              this.stateInProcessingInstruction(c);
              break;
            }
            case u.InNamedEntity: {
              this.stateInNamedEntity(c);
              break;
            }
            case u.BeforeEntity: {
              this.stateBeforeEntity(c);
              break;
            }
            case u.InHexEntity: {
              this.stateInHexEntity(c);
              break;
            }
            case u.InNumericEntity: {
              this.stateInNumericEntity(c);
              break;
            }
            default:
              this.stateBeforeNumericEntity(c);
          }
          this.index++;
        }
        this.cleanup();
      }, s.prototype.finish = function() {
        this.state === u.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, s.prototype.handleTrailingData = function() {
        var c = this.buffer.length + this.offset;
        this.state === u.InCommentLike ? this.currentSequence === h.CdataEnd ? this.cbs.oncdata(this.sectionStart, c, 0) : this.cbs.oncomment(this.sectionStart, c, 0) : this.state === u.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InTagName || this.state === u.BeforeAttributeName || this.state === u.BeforeAttributeValue || this.state === u.AfterAttributeName || this.state === u.InAttributeName || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueDq || this.state === u.InAttributeValueNq || this.state === u.InClosingTagName || this.cbs.ontext(this.sectionStart, c);
      }, s.prototype.emitPartial = function(c, E) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribdata(c, E) : this.cbs.ontext(c, E);
      }, s.prototype.emitCodePoint = function(c) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribentity(c) : this.cbs.ontextentity(c);
      }, s;
    }()
  );
  r.default = y;
})(Au);
var Ti = D && D.__createBinding || (Object.create ? function(r, e, t, u) {
  u === void 0 && (u = t);
  var n = Object.getOwnPropertyDescriptor(e, t);
  (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, u, n);
} : function(r, e, t, u) {
  u === void 0 && (u = t), r[u] = e[t];
}), Ai = D && D.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), _i = D && D.__importStar || function(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && Ti(e, r, t);
  return Ai(e, r), e;
};
Object.defineProperty(Ke, "__esModule", { value: !0 });
Ke.Parser = void 0;
var mt = _i(Au), sr = et, ke = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), W = /* @__PURE__ */ new Set(["p"]), or = /* @__PURE__ */ new Set(["thead", "tbody"]), cr = /* @__PURE__ */ new Set(["dd", "dt"]), lr = /* @__PURE__ */ new Set(["rt", "rp"]), Oi = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", W],
  ["h1", W],
  ["h2", W],
  ["h3", W],
  ["h4", W],
  ["h5", W],
  ["h6", W],
  ["select", ke],
  ["input", ke],
  ["output", ke],
  ["button", ke],
  ["datalist", ke],
  ["textarea", ke],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", cr],
  ["dt", cr],
  ["address", W],
  ["article", W],
  ["aside", W],
  ["blockquote", W],
  ["details", W],
  ["div", W],
  ["dl", W],
  ["fieldset", W],
  ["figcaption", W],
  ["figure", W],
  ["footer", W],
  ["form", W],
  ["header", W],
  ["hr", W],
  ["main", W],
  ["nav", W],
  ["ol", W],
  ["pre", W],
  ["section", W],
  ["table", W],
  ["ul", W],
  ["rt", lr],
  ["rp", lr],
  ["tbody", or],
  ["tfoot", or]
]), Ni = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), fr = /* @__PURE__ */ new Set(["math", "svg"]), dr = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), Ci = /\s|\//, Ii = (
  /** @class */
  function() {
    function r(e, t) {
      t === void 0 && (t = {});
      var u, n, i, o, l;
      this.options = t, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.lowerCaseTagNames = (u = t.lowerCaseTags) !== null && u !== void 0 ? u : !t.xmlMode, this.lowerCaseAttributeNames = (n = t.lowerCaseAttributeNames) !== null && n !== void 0 ? n : !t.xmlMode, this.tokenizer = new ((i = t.Tokenizer) !== null && i !== void 0 ? i : mt.default)(this.options, this), (l = (o = this.cbs).onparserinit) === null || l === void 0 || l.call(o, this);
    }
    return r.prototype.ontext = function(e, t) {
      var u, n, i = this.getSlice(e, t);
      this.endIndex = t - 1, (n = (u = this.cbs).ontext) === null || n === void 0 || n.call(u, i), this.startIndex = t;
    }, r.prototype.ontextentity = function(e) {
      var t, u, n = this.tokenizer.getSectionStart();
      this.endIndex = n - 1, (u = (t = this.cbs).ontext) === null || u === void 0 || u.call(t, (0, sr.fromCodePoint)(e)), this.startIndex = n;
    }, r.prototype.isVoidElement = function(e) {
      return !this.options.xmlMode && Ni.has(e);
    }, r.prototype.onopentagname = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      this.lowerCaseTagNames && (u = u.toLowerCase()), this.emitOpenTag(u);
    }, r.prototype.emitOpenTag = function(e) {
      var t, u, n, i;
      this.openTagStart = this.startIndex, this.tagname = e;
      var o = !this.options.xmlMode && Oi.get(e);
      if (o)
        for (; this.stack.length > 0 && o.has(this.stack[this.stack.length - 1]); ) {
          var l = this.stack.pop();
          (u = (t = this.cbs).onclosetag) === null || u === void 0 || u.call(t, l, !0);
        }
      this.isVoidElement(e) || (this.stack.push(e), fr.has(e) ? this.foreignContext.push(!0) : dr.has(e) && this.foreignContext.push(!1)), (i = (n = this.cbs).onopentagname) === null || i === void 0 || i.call(n, e), this.cbs.onopentag && (this.attribs = {});
    }, r.prototype.endOpenTag = function(e) {
      var t, u;
      this.startIndex = this.openTagStart, this.attribs && ((u = (t = this.cbs).onopentag) === null || u === void 0 || u.call(t, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, r.prototype.onopentagend = function(e) {
      this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
    }, r.prototype.onclosetag = function(e, t) {
      var u, n, i, o, l, a;
      this.endIndex = t;
      var f = this.getSlice(e, t);
      if (this.lowerCaseTagNames && (f = f.toLowerCase()), (fr.has(f) || dr.has(f)) && this.foreignContext.pop(), this.isVoidElement(f))
        !this.options.xmlMode && f === "br" && ((n = (u = this.cbs).onopentagname) === null || n === void 0 || n.call(u, "br"), (o = (i = this.cbs).onopentag) === null || o === void 0 || o.call(i, "br", {}, !0), (a = (l = this.cbs).onclosetag) === null || a === void 0 || a.call(l, "br", !1));
      else {
        var h = this.stack.lastIndexOf(f);
        if (h !== -1)
          if (this.cbs.onclosetag)
            for (var y = this.stack.length - h; y--; )
              this.cbs.onclosetag(this.stack.pop(), y !== 0);
          else
            this.stack.length = h;
        else !this.options.xmlMode && f === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = t + 1;
    }, r.prototype.onselfclosingtag = function(e) {
      this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
    }, r.prototype.closeCurrentTag = function(e) {
      var t, u, n = this.tagname;
      this.endOpenTag(e), this.stack[this.stack.length - 1] === n && ((u = (t = this.cbs).onclosetag) === null || u === void 0 || u.call(t, n, !e), this.stack.pop());
    }, r.prototype.onattribname = function(e, t) {
      this.startIndex = e;
      var u = this.getSlice(e, t);
      this.attribname = this.lowerCaseAttributeNames ? u.toLowerCase() : u;
    }, r.prototype.onattribdata = function(e, t) {
      this.attribvalue += this.getSlice(e, t);
    }, r.prototype.onattribentity = function(e) {
      this.attribvalue += (0, sr.fromCodePoint)(e);
    }, r.prototype.onattribend = function(e, t) {
      var u, n;
      this.endIndex = t, (n = (u = this.cbs).onattribute) === null || n === void 0 || n.call(u, this.attribname, this.attribvalue, e === mt.QuoteType.Double ? '"' : e === mt.QuoteType.Single ? "'" : e === mt.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, r.prototype.getInstructionName = function(e) {
      var t = e.search(Ci), u = t < 0 ? e : e.substr(0, t);
      return this.lowerCaseTagNames && (u = u.toLowerCase()), u;
    }, r.prototype.ondeclaration = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      if (this.cbs.onprocessinginstruction) {
        var n = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("!".concat(n), "!".concat(u));
      }
      this.startIndex = t + 1;
    }, r.prototype.onprocessinginstruction = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      if (this.cbs.onprocessinginstruction) {
        var n = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("?".concat(n), "?".concat(u));
      }
      this.startIndex = t + 1;
    }, r.prototype.oncomment = function(e, t, u) {
      var n, i, o, l;
      this.endIndex = t, (i = (n = this.cbs).oncomment) === null || i === void 0 || i.call(n, this.getSlice(e, t - u)), (l = (o = this.cbs).oncommentend) === null || l === void 0 || l.call(o), this.startIndex = t + 1;
    }, r.prototype.oncdata = function(e, t, u) {
      var n, i, o, l, a, f, h, y, s, c;
      this.endIndex = t;
      var E = this.getSlice(e, t - u);
      this.options.xmlMode || this.options.recognizeCDATA ? ((i = (n = this.cbs).oncdatastart) === null || i === void 0 || i.call(n), (l = (o = this.cbs).ontext) === null || l === void 0 || l.call(o, E), (f = (a = this.cbs).oncdataend) === null || f === void 0 || f.call(a)) : ((y = (h = this.cbs).oncomment) === null || y === void 0 || y.call(h, "[CDATA[".concat(E, "]]")), (c = (s = this.cbs).oncommentend) === null || c === void 0 || c.call(s)), this.startIndex = t + 1;
    }, r.prototype.onend = function() {
      var e, t;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var u = this.stack.length; u > 0; this.cbs.onclosetag(this.stack[--u], !0))
          ;
      }
      (t = (e = this.cbs).onend) === null || t === void 0 || t.call(e);
    }, r.prototype.reset = function() {
      var e, t, u, n;
      (t = (e = this.cbs).onreset) === null || t === void 0 || t.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (n = (u = this.cbs).onparserinit) === null || n === void 0 || n.call(u, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, r.prototype.parseComplete = function(e) {
      this.reset(), this.end(e);
    }, r.prototype.getSlice = function(e, t) {
      for (; e - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var u = this.buffers[0].slice(e - this.bufferOffset, t - this.bufferOffset); t - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), u += this.buffers[0].slice(0, t - this.bufferOffset);
      return u;
    }, r.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, r.prototype.write = function(e) {
      var t, u;
      if (this.ended) {
        (u = (t = this.cbs).onerror) === null || u === void 0 || u.call(t, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
    }, r.prototype.end = function(e) {
      var t, u;
      if (this.ended) {
        (u = (t = this.cbs).onerror) === null || u === void 0 || u.call(t, new Error(".end() after done!"));
        return;
      }
      e && this.write(e), this.ended = !0, this.tokenizer.end();
    }, r.prototype.pause = function() {
      this.tokenizer.pause();
    }, r.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, r.prototype.parseChunk = function(e) {
      this.write(e);
    }, r.prototype.done = function(e) {
      this.end(e);
    }, r;
  }()
);
Ke.Parser = Ii;
var ye = {}, ze = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Doctype = r.CDATA = r.Tag = r.Style = r.Script = r.Comment = r.Directive = r.Text = r.Root = r.isTag = r.ElementType = void 0;
  var e;
  (function(u) {
    u.Root = "root", u.Text = "text", u.Directive = "directive", u.Comment = "comment", u.Script = "script", u.Style = "style", u.Tag = "tag", u.CDATA = "cdata", u.Doctype = "doctype";
  })(e = r.ElementType || (r.ElementType = {}));
  function t(u) {
    return u.type === e.Tag || u.type === e.Script || u.type === e.Style;
  }
  r.isTag = t, r.Root = e.Root, r.Text = e.Text, r.Directive = e.Directive, r.Comment = e.Comment, r.Script = e.Script, r.Style = e.Style, r.Tag = e.Tag, r.CDATA = e.CDATA, r.Doctype = e.Doctype;
})(ze);
var j = {}, Se = D && D.__extends || /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, n) {
      u.__proto__ = n;
    } || function(u, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (u[i] = n[i]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function u() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (u.prototype = t.prototype, new u());
  };
}(), Qe = D && D.__assign || function() {
  return Qe = Object.assign || function(r) {
    for (var e, t = 1, u = arguments.length; t < u; t++) {
      e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, Qe.apply(this, arguments);
};
Object.defineProperty(j, "__esModule", { value: !0 });
j.cloneNode = j.hasChildren = j.isDocument = j.isDirective = j.isComment = j.isText = j.isCDATA = j.isTag = j.Element = j.Document = j.CDATA = j.NodeWithChildren = j.ProcessingInstruction = j.Comment = j.Text = j.DataNode = j.Node = void 0;
var ae = ze, Nu = (
  /** @class */
  function() {
    function r() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(r.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(e) {
        this.parent = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(e) {
        this.prev = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(e) {
        this.next = e;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.cloneNode = function(e) {
      return e === void 0 && (e = !1), Cu(this, e);
    }, r;
  }()
);
j.Node = Nu;
var Bt = (
  /** @class */
  function(r) {
    Se(e, r);
    function e(t) {
      var u = r.call(this) || this;
      return u.data = t, u;
    }
    return Object.defineProperty(e.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(t) {
        this.data = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Nu)
);
j.DataNode = Bt;
var $r = (
  /** @class */
  function(r) {
    Se(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = ae.ElementType.Text, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Bt)
);
j.Text = $r;
var Ur = (
  /** @class */
  function(r) {
    Se(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = ae.ElementType.Comment, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Bt)
);
j.Comment = Ur;
var Fr = (
  /** @class */
  function(r) {
    Se(e, r);
    function e(t, u) {
      var n = r.call(this, u) || this;
      return n.name = t, n.type = ae.ElementType.Directive, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Bt)
);
j.ProcessingInstruction = Fr;
var $t = (
  /** @class */
  function(r) {
    Se(e, r);
    function e(t) {
      var u = r.call(this) || this;
      return u.children = t, u;
    }
    return Object.defineProperty(e.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var t;
        return (t = this.children[0]) !== null && t !== void 0 ? t : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(t) {
        this.children = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Nu)
);
j.NodeWithChildren = $t;
var Hr = (
  /** @class */
  function(r) {
    Se(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = ae.ElementType.CDATA, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }($t)
);
j.CDATA = Hr;
var Vr = (
  /** @class */
  function(r) {
    Se(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = ae.ElementType.Root, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }($t)
);
j.Document = Vr;
var zr = (
  /** @class */
  function(r) {
    Se(e, r);
    function e(t, u, n, i) {
      n === void 0 && (n = []), i === void 0 && (i = t === "script" ? ae.ElementType.Script : t === "style" ? ae.ElementType.Style : ae.ElementType.Tag);
      var o = r.call(this, n) || this;
      return o.name = t, o.attribs = u, o.type = i, o;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(t) {
        this.name = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t = this;
        return Object.keys(this.attribs).map(function(u) {
          var n, i;
          return {
            name: u,
            value: t.attribs[u],
            namespace: (n = t["x-attribsNamespace"]) === null || n === void 0 ? void 0 : n[u],
            prefix: (i = t["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[u]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }($t)
);
j.Element = zr;
function Gr(r) {
  return (0, ae.isTag)(r);
}
j.isTag = Gr;
function Wr(r) {
  return r.type === ae.ElementType.CDATA;
}
j.isCDATA = Wr;
function Yr(r) {
  return r.type === ae.ElementType.Text;
}
j.isText = Yr;
function Xr(r) {
  return r.type === ae.ElementType.Comment;
}
j.isComment = Xr;
function Jr(r) {
  return r.type === ae.ElementType.Directive;
}
j.isDirective = Jr;
function Zr(r) {
  return r.type === ae.ElementType.Root;
}
j.isDocument = Zr;
function Pi(r) {
  return Object.prototype.hasOwnProperty.call(r, "children");
}
j.hasChildren = Pi;
function Cu(r, e) {
  e === void 0 && (e = !1);
  var t;
  if (Yr(r))
    t = new $r(r.data);
  else if (Xr(r))
    t = new Ur(r.data);
  else if (Gr(r)) {
    var u = e ? tu(r.children) : [], n = new zr(r.name, Qe({}, r.attribs), u);
    u.forEach(function(a) {
      return a.parent = n;
    }), r.namespace != null && (n.namespace = r.namespace), r["x-attribsNamespace"] && (n["x-attribsNamespace"] = Qe({}, r["x-attribsNamespace"])), r["x-attribsPrefix"] && (n["x-attribsPrefix"] = Qe({}, r["x-attribsPrefix"])), t = n;
  } else if (Wr(r)) {
    var u = e ? tu(r.children) : [], i = new Hr(u);
    u.forEach(function(f) {
      return f.parent = i;
    }), t = i;
  } else if (Zr(r)) {
    var u = e ? tu(r.children) : [], o = new Vr(u);
    u.forEach(function(f) {
      return f.parent = o;
    }), r["x-mode"] && (o["x-mode"] = r["x-mode"]), t = o;
  } else if (Jr(r)) {
    var l = new Fr(r.name, r.data);
    r["x-name"] != null && (l["x-name"] = r["x-name"], l["x-publicId"] = r["x-publicId"], l["x-systemId"] = r["x-systemId"]), t = l;
  } else
    throw new Error("Not implemented yet: ".concat(r.type));
  return t.startIndex = r.startIndex, t.endIndex = r.endIndex, r.sourceCodeLocation != null && (t.sourceCodeLocation = r.sourceCodeLocation), t;
}
j.cloneNode = Cu;
function tu(r) {
  for (var e = r.map(function(u) {
    return Cu(u, !0);
  }), t = 1; t < e.length; t++)
    e[t].prev = e[t - 1], e[t - 1].next = e[t];
  return e;
}
(function(r) {
  var e = D && D.__createBinding || (Object.create ? function(l, a, f, h) {
    h === void 0 && (h = f);
    var y = Object.getOwnPropertyDescriptor(a, f);
    (!y || ("get" in y ? !a.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return a[f];
    } }), Object.defineProperty(l, h, y);
  } : function(l, a, f, h) {
    h === void 0 && (h = f), l[h] = a[f];
  }), t = D && D.__exportStar || function(l, a) {
    for (var f in l) f !== "default" && !Object.prototype.hasOwnProperty.call(a, f) && e(a, l, f);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomHandler = void 0;
  var u = ze, n = j;
  t(j, r);
  var i = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function l(a, f, h) {
        this.dom = [], this.root = new n.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof f == "function" && (h = f, f = i), typeof a == "object" && (f = a, a = void 0), this.callback = a ?? null, this.options = f ?? i, this.elementCB = h ?? null;
      }
      return l.prototype.onparserinit = function(a) {
        this.parser = a;
      }, l.prototype.onreset = function() {
        this.dom = [], this.root = new n.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, l.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, l.prototype.onerror = function(a) {
        this.handleCallback(a);
      }, l.prototype.onclosetag = function() {
        this.lastNode = null;
        var a = this.tagStack.pop();
        this.options.withEndIndices && (a.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(a);
      }, l.prototype.onopentag = function(a, f) {
        var h = this.options.xmlMode ? u.ElementType.Tag : void 0, y = new n.Element(a, f, void 0, h);
        this.addNode(y), this.tagStack.push(y);
      }, l.prototype.ontext = function(a) {
        var f = this.lastNode;
        if (f && f.type === u.ElementType.Text)
          f.data += a, this.options.withEndIndices && (f.endIndex = this.parser.endIndex);
        else {
          var h = new n.Text(a);
          this.addNode(h), this.lastNode = h;
        }
      }, l.prototype.oncomment = function(a) {
        if (this.lastNode && this.lastNode.type === u.ElementType.Comment) {
          this.lastNode.data += a;
          return;
        }
        var f = new n.Comment(a);
        this.addNode(f), this.lastNode = f;
      }, l.prototype.oncommentend = function() {
        this.lastNode = null;
      }, l.prototype.oncdatastart = function() {
        var a = new n.Text(""), f = new n.CDATA([a]);
        this.addNode(f), a.parent = f, this.lastNode = a;
      }, l.prototype.oncdataend = function() {
        this.lastNode = null;
      }, l.prototype.onprocessinginstruction = function(a, f) {
        var h = new n.ProcessingInstruction(a, f);
        this.addNode(h);
      }, l.prototype.handleCallback = function(a) {
        if (typeof this.callback == "function")
          this.callback(a, this.dom);
        else if (a)
          throw a;
      }, l.prototype.addNode = function(a) {
        var f = this.tagStack[this.tagStack.length - 1], h = f.children[f.children.length - 1];
        this.options.withStartIndices && (a.startIndex = this.parser.startIndex), this.options.withEndIndices && (a.endIndex = this.parser.endIndex), f.children.push(a), h && (a.prev = h, h.next = a), a.parent = f, this.lastNode = null;
      }, l;
    }()
  );
  r.DomHandler = o, r.default = o;
})(ye);
var _t = {}, Te = {}, st = {}, Qr = {}, Oe = {}, Iu = {};
Object.defineProperty(Iu, "__esModule", { value: !0 });
function gt(r) {
  for (var e = 1; e < r.length; e++)
    r[e][0] += r[e - 1][0] + 1;
  return r;
}
Iu.default = new Map(/* @__PURE__ */ gt([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ gt([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ gt([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ gt([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var It = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.getCodePoint = r.xmlReplacer = void 0, r.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var e = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  r.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(n, i) {
    return n.codePointAt(i);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(n, i) {
      return (n.charCodeAt(i) & 64512) === 55296 ? (n.charCodeAt(i) - 55296) * 1024 + n.charCodeAt(i + 1) - 56320 + 65536 : n.charCodeAt(i);
    }
  );
  function t(n) {
    for (var i = "", o = 0, l; (l = r.xmlReplacer.exec(n)) !== null; ) {
      var a = l.index, f = n.charCodeAt(a), h = e.get(f);
      h !== void 0 ? (i += n.substring(o, a) + h, o = a + 1) : (i += "".concat(n.substring(o, a), "&#x").concat((0, r.getCodePoint)(n, a).toString(16), ";"), o = r.xmlReplacer.lastIndex += +((f & 64512) === 55296));
    }
    return i + n.substr(o);
  }
  r.encodeXML = t, r.escape = t;
  function u(n, i) {
    return function(l) {
      for (var a, f = 0, h = ""; a = n.exec(l); )
        f !== a.index && (h += l.substring(f, a.index)), h += i.get(a[0].charCodeAt(0)), f = a.index + 1;
      return h + l.substring(f);
    };
  }
  r.escapeUTF8 = u(/[&<>'"]/g, e), r.escapeAttribute = u(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), r.escapeText = u(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(It);
var Ri = D && D.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(Oe, "__esModule", { value: !0 });
Oe.encodeNonAsciiHTML = Oe.encodeHTML = void 0;
var Di = Ri(Iu), Kr = It, Li = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function Mi(r) {
  return en(Li, r);
}
Oe.encodeHTML = Mi;
function ki(r) {
  return en(Kr.xmlReplacer, r);
}
Oe.encodeNonAsciiHTML = ki;
function en(r, e) {
  for (var t = "", u = 0, n; (n = r.exec(e)) !== null; ) {
    var i = n.index;
    t += e.substring(u, i);
    var o = e.charCodeAt(i), l = Di.default.get(o);
    if (typeof l == "object") {
      if (i + 1 < e.length) {
        var a = e.charCodeAt(i + 1), f = typeof l.n == "number" ? l.n === a ? l.o : void 0 : l.n.get(a);
        if (f !== void 0) {
          t += f, u = r.lastIndex += 1;
          continue;
        }
      }
      l = l.v;
    }
    if (l !== void 0)
      t += l, u = i + 1;
    else {
      var h = (0, Kr.getCodePoint)(e, i);
      t += "&#x".concat(h.toString(16), ";"), u = r.lastIndex += +(h !== o);
    }
  }
  return t + e.substr(u);
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXMLStrict = r.decodeHTML5Strict = r.decodeHTML4Strict = r.decodeHTML5 = r.decodeHTML4 = r.decodeHTMLAttribute = r.decodeHTMLStrict = r.decodeHTML = r.decodeXML = r.DecodingMode = r.EntityDecoder = r.encodeHTML5 = r.encodeHTML4 = r.encodeNonAsciiHTML = r.encodeHTML = r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.encode = r.decodeStrict = r.decode = r.EncodingMode = r.EntityLevel = void 0;
  var e = et, t = Oe, u = It, n;
  (function(s) {
    s[s.XML = 0] = "XML", s[s.HTML = 1] = "HTML";
  })(n = r.EntityLevel || (r.EntityLevel = {}));
  var i;
  (function(s) {
    s[s.UTF8 = 0] = "UTF8", s[s.ASCII = 1] = "ASCII", s[s.Extensive = 2] = "Extensive", s[s.Attribute = 3] = "Attribute", s[s.Text = 4] = "Text";
  })(i = r.EncodingMode || (r.EncodingMode = {}));
  function o(s, c) {
    c === void 0 && (c = n.XML);
    var E = typeof c == "number" ? c : c.level;
    if (E === n.HTML) {
      var _ = typeof c == "object" ? c.mode : void 0;
      return (0, e.decodeHTML)(s, _);
    }
    return (0, e.decodeXML)(s);
  }
  r.decode = o;
  function l(s, c) {
    var E;
    c === void 0 && (c = n.XML);
    var _ = typeof c == "number" ? { level: c } : c;
    return (E = _.mode) !== null && E !== void 0 || (_.mode = e.DecodingMode.Strict), o(s, _);
  }
  r.decodeStrict = l;
  function a(s, c) {
    c === void 0 && (c = n.XML);
    var E = typeof c == "number" ? { level: c } : c;
    return E.mode === i.UTF8 ? (0, u.escapeUTF8)(s) : E.mode === i.Attribute ? (0, u.escapeAttribute)(s) : E.mode === i.Text ? (0, u.escapeText)(s) : E.level === n.HTML ? E.mode === i.ASCII ? (0, t.encodeNonAsciiHTML)(s) : (0, t.encodeHTML)(s) : (0, u.encodeXML)(s);
  }
  r.encode = a;
  var f = It;
  Object.defineProperty(r, "encodeXML", { enumerable: !0, get: function() {
    return f.encodeXML;
  } }), Object.defineProperty(r, "escape", { enumerable: !0, get: function() {
    return f.escape;
  } }), Object.defineProperty(r, "escapeUTF8", { enumerable: !0, get: function() {
    return f.escapeUTF8;
  } }), Object.defineProperty(r, "escapeAttribute", { enumerable: !0, get: function() {
    return f.escapeAttribute;
  } }), Object.defineProperty(r, "escapeText", { enumerable: !0, get: function() {
    return f.escapeText;
  } });
  var h = Oe;
  Object.defineProperty(r, "encodeHTML", { enumerable: !0, get: function() {
    return h.encodeHTML;
  } }), Object.defineProperty(r, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return h.encodeNonAsciiHTML;
  } }), Object.defineProperty(r, "encodeHTML4", { enumerable: !0, get: function() {
    return h.encodeHTML;
  } }), Object.defineProperty(r, "encodeHTML5", { enumerable: !0, get: function() {
    return h.encodeHTML;
  } });
  var y = et;
  Object.defineProperty(r, "EntityDecoder", { enumerable: !0, get: function() {
    return y.EntityDecoder;
  } }), Object.defineProperty(r, "DecodingMode", { enumerable: !0, get: function() {
    return y.DecodingMode;
  } }), Object.defineProperty(r, "decodeXML", { enumerable: !0, get: function() {
    return y.decodeXML;
  } }), Object.defineProperty(r, "decodeHTML", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return y.decodeHTMLAttribute;
  } }), Object.defineProperty(r, "decodeHTML4", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML5", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeXMLStrict", { enumerable: !0, get: function() {
    return y.decodeXML;
  } });
})(Qr);
var Be = {};
Object.defineProperty(Be, "__esModule", { value: !0 });
Be.attributeNames = Be.elementNames = void 0;
Be.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
Be.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
var qe = D && D.__assign || function() {
  return qe = Object.assign || function(r) {
    for (var e, t = 1, u = arguments.length; t < u; t++) {
      e = arguments[t];
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, qe.apply(this, arguments);
}, ji = D && D.__createBinding || (Object.create ? function(r, e, t, u) {
  u === void 0 && (u = t);
  var n = Object.getOwnPropertyDescriptor(e, t);
  (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, u, n);
} : function(r, e, t, u) {
  u === void 0 && (u = t), r[u] = e[t];
}), qi = D && D.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), Bi = D && D.__importStar || function(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && ji(e, r, t);
  return qi(e, r), e;
};
Object.defineProperty(st, "__esModule", { value: !0 });
st.render = void 0;
var me = Bi(ze), Pt = Qr, tn = Be, $i = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function Ui(r) {
  return r.replace(/"/g, "&quot;");
}
function Fi(r, e) {
  var t;
  if (r) {
    var u = ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) === !1 ? Ui : e.xmlMode || e.encodeEntities !== "utf8" ? Pt.encodeXML : Pt.escapeAttribute;
    return Object.keys(r).map(function(n) {
      var i, o, l = (i = r[n]) !== null && i !== void 0 ? i : "";
      return e.xmlMode === "foreign" && (n = (o = tn.attributeNames.get(n)) !== null && o !== void 0 ? o : n), !e.emptyAttrs && !e.xmlMode && l === "" ? n : "".concat(n, '="').concat(u(l), '"');
    }).join(" ");
  }
}
var hr = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function Ut(r, e) {
  e === void 0 && (e = {});
  for (var t = ("length" in r) ? r : [r], u = "", n = 0; n < t.length; n++)
    u += Hi(t[n], e);
  return u;
}
st.render = Ut;
st.default = Ut;
function Hi(r, e) {
  switch (r.type) {
    case me.Root:
      return Ut(r.children, e);
    case me.Doctype:
    case me.Directive:
      return Wi(r);
    case me.Comment:
      return Ji(r);
    case me.CDATA:
      return Xi(r);
    case me.Script:
    case me.Style:
    case me.Tag:
      return Gi(r, e);
    case me.Text:
      return Yi(r, e);
  }
}
var Vi = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), zi = /* @__PURE__ */ new Set(["svg", "math"]);
function Gi(r, e) {
  var t;
  e.xmlMode === "foreign" && (r.name = (t = tn.elementNames.get(r.name)) !== null && t !== void 0 ? t : r.name, r.parent && Vi.has(r.parent.name) && (e = qe(qe({}, e), { xmlMode: !1 }))), !e.xmlMode && zi.has(r.name) && (e = qe(qe({}, e), { xmlMode: "foreign" }));
  var u = "<".concat(r.name), n = Fi(r.attribs, e);
  return n && (u += " ".concat(n)), r.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && hr.has(r.name)
  )) ? (e.xmlMode || (u += " "), u += "/>") : (u += ">", r.children.length > 0 && (u += Ut(r.children, e)), (e.xmlMode || !hr.has(r.name)) && (u += "</".concat(r.name, ">"))), u;
}
function Wi(r) {
  return "<".concat(r.data, ">");
}
function Yi(r, e) {
  var t, u = r.data || "";
  return ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) !== !1 && !(!e.xmlMode && r.parent && $i.has(r.parent.name)) && (u = e.xmlMode || e.encodeEntities !== "utf8" ? (0, Pt.encodeXML)(u) : (0, Pt.escapeText)(u)), u;
}
function Xi(r) {
  return "<![CDATA[".concat(r.children[0].data, "]]>");
}
function Ji(r) {
  return "<!--".concat(r.data, "-->");
}
var Zi = D && D.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(Te, "__esModule", { value: !0 });
Te.getOuterHTML = un;
Te.getInnerHTML = ea;
Te.getText = Ot;
Te.textContent = ou;
Te.innerText = cu;
var de = ye, Qi = Zi(st), Ki = ze;
function un(r, e) {
  return (0, Qi.default)(r, e);
}
function ea(r, e) {
  return (0, de.hasChildren)(r) ? r.children.map(function(t) {
    return un(t, e);
  }).join("") : "";
}
function Ot(r) {
  return Array.isArray(r) ? r.map(Ot).join("") : (0, de.isTag)(r) ? r.name === "br" ? `
` : Ot(r.children) : (0, de.isCDATA)(r) ? Ot(r.children) : (0, de.isText)(r) ? r.data : "";
}
function ou(r) {
  return Array.isArray(r) ? r.map(ou).join("") : (0, de.hasChildren)(r) && !(0, de.isComment)(r) ? ou(r.children) : (0, de.isText)(r) ? r.data : "";
}
function cu(r) {
  return Array.isArray(r) ? r.map(cu).join("") : (0, de.hasChildren)(r) && (r.type === Ki.ElementType.Tag || (0, de.isCDATA)(r)) ? cu(r.children) : (0, de.isText)(r) ? r.data : "";
}
var he = {};
Object.defineProperty(he, "__esModule", { value: !0 });
he.getChildren = rn;
he.getParent = nn;
he.getSiblings = ta;
he.getAttributeValue = ua;
he.hasAttrib = ra;
he.getName = na;
he.nextElementSibling = ia;
he.prevElementSibling = aa;
var Pu = ye;
function rn(r) {
  return (0, Pu.hasChildren)(r) ? r.children : [];
}
function nn(r) {
  return r.parent || null;
}
function ta(r) {
  var e, t, u = nn(r);
  if (u != null)
    return rn(u);
  for (var n = [r], i = r.prev, o = r.next; i != null; )
    n.unshift(i), e = i, i = e.prev;
  for (; o != null; )
    n.push(o), t = o, o = t.next;
  return n;
}
function ua(r, e) {
  var t;
  return (t = r.attribs) === null || t === void 0 ? void 0 : t[e];
}
function ra(r, e) {
  return r.attribs != null && Object.prototype.hasOwnProperty.call(r.attribs, e) && r.attribs[e] != null;
}
function na(r) {
  return r.name;
}
function ia(r) {
  for (var e, t = r.next; t !== null && !(0, Pu.isTag)(t); )
    e = t, t = e.next;
  return t;
}
function aa(r) {
  for (var e, t = r.prev; t !== null && !(0, Pu.isTag)(t); )
    e = t, t = e.prev;
  return t;
}
var Ae = {};
Object.defineProperty(Ae, "__esModule", { value: !0 });
Ae.removeElement = ot;
Ae.replaceElement = sa;
Ae.appendChild = oa;
Ae.append = ca;
Ae.prependChild = la;
Ae.prepend = fa;
function ot(r) {
  if (r.prev && (r.prev.next = r.next), r.next && (r.next.prev = r.prev), r.parent) {
    var e = r.parent.children, t = e.lastIndexOf(r);
    t >= 0 && e.splice(t, 1);
  }
  r.next = null, r.prev = null, r.parent = null;
}
function sa(r, e) {
  var t = e.prev = r.prev;
  t && (t.next = e);
  var u = e.next = r.next;
  u && (u.prev = e);
  var n = e.parent = r.parent;
  if (n) {
    var i = n.children;
    i[i.lastIndexOf(r)] = e, r.parent = null;
  }
}
function oa(r, e) {
  if (ot(e), e.next = null, e.parent = r, r.children.push(e) > 1) {
    var t = r.children[r.children.length - 2];
    t.next = e, e.prev = t;
  } else
    e.prev = null;
}
function ca(r, e) {
  ot(e);
  var t = r.parent, u = r.next;
  if (e.next = u, e.prev = r, r.next = e, e.parent = t, u) {
    if (u.prev = e, t) {
      var n = t.children;
      n.splice(n.lastIndexOf(u), 0, e);
    }
  } else t && t.children.push(e);
}
function la(r, e) {
  if (ot(e), e.parent = r, e.prev = null, r.children.unshift(e) !== 1) {
    var t = r.children[1];
    t.prev = e, e.next = t;
  } else
    e.next = null;
}
function fa(r, e) {
  ot(e);
  var t = r.parent;
  if (t) {
    var u = t.children;
    u.splice(u.indexOf(r), 0, e);
  }
  r.prev && (r.prev.next = e), e.parent = t, e.prev = r.prev, e.next = r, r.prev = e;
}
var ve = {};
Object.defineProperty(ve, "__esModule", { value: !0 });
ve.filter = da;
ve.find = an;
ve.findOneChild = ha;
ve.findOne = sn;
ve.existsOne = on;
ve.findAll = pa;
var Ne = ye;
function da(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), an(r, Array.isArray(e) ? e : [e], t, u);
}
function an(r, e, t, u) {
  for (var n = [], i = [Array.isArray(e) ? e : [e]], o = [0]; ; ) {
    if (o[0] >= i[0].length) {
      if (o.length === 1)
        return n;
      i.shift(), o.shift();
      continue;
    }
    var l = i[0][o[0]++];
    if (r(l) && (n.push(l), --u <= 0))
      return n;
    t && (0, Ne.hasChildren)(l) && l.children.length > 0 && (o.unshift(0), i.unshift(l.children));
  }
}
function ha(r, e) {
  return e.find(r);
}
function sn(r, e, t) {
  t === void 0 && (t = !0);
  for (var u = Array.isArray(e) ? e : [e], n = 0; n < u.length; n++) {
    var i = u[n];
    if ((0, Ne.isTag)(i) && r(i))
      return i;
    if (t && (0, Ne.hasChildren)(i) && i.children.length > 0) {
      var o = sn(r, i.children, !0);
      if (o)
        return o;
    }
  }
  return null;
}
function on(r, e) {
  return (Array.isArray(e) ? e : [e]).some(function(t) {
    return (0, Ne.isTag)(t) && r(t) || (0, Ne.hasChildren)(t) && on(r, t.children);
  });
}
function pa(r, e) {
  for (var t = [], u = [Array.isArray(e) ? e : [e]], n = [0]; ; ) {
    if (n[0] >= u[0].length) {
      if (u.length === 1)
        return t;
      u.shift(), n.shift();
      continue;
    }
    var i = u[0][n[0]++];
    (0, Ne.isTag)(i) && r(i) && t.push(i), (0, Ne.hasChildren)(i) && i.children.length > 0 && (n.unshift(0), u.unshift(i.children));
  }
}
var we = {};
Object.defineProperty(we, "__esModule", { value: !0 });
we.testElement = ma;
we.getElements = ga;
we.getElementById = ya;
we.getElementsByTagName = xa;
we.getElementsByClassName = va;
we.getElementsByTagType = wa;
var _e = ye, ct = ve, Rt = {
  tag_name: function(r) {
    return typeof r == "function" ? function(e) {
      return (0, _e.isTag)(e) && r(e.name);
    } : r === "*" ? _e.isTag : function(e) {
      return (0, _e.isTag)(e) && e.name === r;
    };
  },
  tag_type: function(r) {
    return typeof r == "function" ? function(e) {
      return r(e.type);
    } : function(e) {
      return e.type === r;
    };
  },
  tag_contains: function(r) {
    return typeof r == "function" ? function(e) {
      return (0, _e.isText)(e) && r(e.data);
    } : function(e) {
      return (0, _e.isText)(e) && e.data === r;
    };
  }
};
function Ru(r, e) {
  return typeof e == "function" ? function(t) {
    return (0, _e.isTag)(t) && e(t.attribs[r]);
  } : function(t) {
    return (0, _e.isTag)(t) && t.attribs[r] === e;
  };
}
function ba(r, e) {
  return function(t) {
    return r(t) || e(t);
  };
}
function cn(r) {
  var e = Object.keys(r).map(function(t) {
    var u = r[t];
    return Object.prototype.hasOwnProperty.call(Rt, t) ? Rt[t](u) : Ru(t, u);
  });
  return e.length === 0 ? null : e.reduce(ba);
}
function ma(r, e) {
  var t = cn(r);
  return t ? t(e) : !0;
}
function ga(r, e, t, u) {
  u === void 0 && (u = 1 / 0);
  var n = cn(r);
  return n ? (0, ct.filter)(n, e, t, u) : [];
}
function ya(r, e, t) {
  return t === void 0 && (t = !0), Array.isArray(e) || (e = [e]), (0, ct.findOne)(Ru("id", r), e, t);
}
function xa(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, ct.filter)(Rt.tag_name(r), e, t, u);
}
function va(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, ct.filter)(Ru("class", r), e, t, u);
}
function wa(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, ct.filter)(Rt.tag_type(r), e, t, u);
}
var Ce = {};
Object.defineProperty(Ce, "__esModule", { value: !0 });
Ce.DocumentPosition = void 0;
Ce.removeSubsets = Ea;
Ce.compareDocumentPosition = ln;
Ce.uniqueSort = Sa;
var pr = ye;
function Ea(r) {
  for (var e = r.length; --e >= 0; ) {
    var t = r[e];
    if (e > 0 && r.lastIndexOf(t, e - 1) >= 0) {
      r.splice(e, 1);
      continue;
    }
    for (var u = t.parent; u; u = u.parent)
      if (r.includes(u)) {
        r.splice(e, 1);
        break;
      }
  }
  return r;
}
var ce;
(function(r) {
  r[r.DISCONNECTED = 1] = "DISCONNECTED", r[r.PRECEDING = 2] = "PRECEDING", r[r.FOLLOWING = 4] = "FOLLOWING", r[r.CONTAINS = 8] = "CONTAINS", r[r.CONTAINED_BY = 16] = "CONTAINED_BY";
})(ce || (Ce.DocumentPosition = ce = {}));
function ln(r, e) {
  var t = [], u = [];
  if (r === e)
    return 0;
  for (var n = (0, pr.hasChildren)(r) ? r : r.parent; n; )
    t.unshift(n), n = n.parent;
  for (n = (0, pr.hasChildren)(e) ? e : e.parent; n; )
    u.unshift(n), n = n.parent;
  for (var i = Math.min(t.length, u.length), o = 0; o < i && t[o] === u[o]; )
    o++;
  if (o === 0)
    return ce.DISCONNECTED;
  var l = t[o - 1], a = l.children, f = t[o], h = u[o];
  return a.indexOf(f) > a.indexOf(h) ? l === e ? ce.FOLLOWING | ce.CONTAINED_BY : ce.FOLLOWING : l === r ? ce.PRECEDING | ce.CONTAINS : ce.PRECEDING;
}
function Sa(r) {
  return r = r.filter(function(e, t, u) {
    return !u.includes(e, t + 1);
  }), r.sort(function(e, t) {
    var u = ln(e, t);
    return u & ce.PRECEDING ? -1 : u & ce.FOLLOWING ? 1 : 0;
  }), r;
}
var Du = {};
Object.defineProperty(Du, "__esModule", { value: !0 });
Du.getFeed = Aa;
var Ta = Te, lt = we;
function Aa(r) {
  var e = Dt(Ia, r);
  return e ? e.name === "feed" ? _a(e) : Oa(e) : null;
}
function _a(r) {
  var e, t = r.children, u = {
    type: "atom",
    items: (0, lt.getElementsByTagName)("entry", t).map(function(o) {
      var l, a = o.children, f = { media: fn(a) };
      ie(f, "id", "id", a), ie(f, "title", "title", a);
      var h = (l = Dt("link", a)) === null || l === void 0 ? void 0 : l.attribs.href;
      h && (f.link = h);
      var y = Ee("summary", a) || Ee("content", a);
      y && (f.description = y);
      var s = Ee("updated", a);
      return s && (f.pubDate = new Date(s)), f;
    })
  };
  ie(u, "id", "id", t), ie(u, "title", "title", t);
  var n = (e = Dt("link", t)) === null || e === void 0 ? void 0 : e.attribs.href;
  n && (u.link = n), ie(u, "description", "subtitle", t);
  var i = Ee("updated", t);
  return i && (u.updated = new Date(i)), ie(u, "author", "email", t, !0), u;
}
function Oa(r) {
  var e, t, u = (t = (e = Dt("channel", r.children)) === null || e === void 0 ? void 0 : e.children) !== null && t !== void 0 ? t : [], n = {
    type: r.name.substr(0, 3),
    id: "",
    items: (0, lt.getElementsByTagName)("item", r.children).map(function(o) {
      var l = o.children, a = { media: fn(l) };
      ie(a, "id", "guid", l), ie(a, "title", "title", l), ie(a, "link", "link", l), ie(a, "description", "description", l);
      var f = Ee("pubDate", l) || Ee("dc:date", l);
      return f && (a.pubDate = new Date(f)), a;
    })
  };
  ie(n, "title", "title", u), ie(n, "link", "link", u), ie(n, "description", "description", u);
  var i = Ee("lastBuildDate", u);
  return i && (n.updated = new Date(i)), ie(n, "author", "managingEditor", u, !0), n;
}
var Na = ["url", "type", "lang"], Ca = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function fn(r) {
  return (0, lt.getElementsByTagName)("media:content", r).map(function(e) {
    for (var t = e.attribs, u = {
      medium: t.medium,
      isDefault: !!t.isDefault
    }, n = 0, i = Na; n < i.length; n++) {
      var o = i[n];
      t[o] && (u[o] = t[o]);
    }
    for (var l = 0, a = Ca; l < a.length; l++) {
      var o = a[l];
      t[o] && (u[o] = parseInt(t[o], 10));
    }
    return t.expression && (u.expression = t.expression), u;
  });
}
function Dt(r, e) {
  return (0, lt.getElementsByTagName)(r, e, !0, 1)[0];
}
function Ee(r, e, t) {
  return t === void 0 && (t = !1), (0, Ta.textContent)((0, lt.getElementsByTagName)(r, e, t, 1)).trim();
}
function ie(r, e, t, u, n) {
  n === void 0 && (n = !1);
  var i = Ee(t, u, n);
  i && (r[e] = i);
}
function Ia(r) {
  return r === "rss" || r === "feed" || r === "rdf:RDF";
}
(function(r) {
  var e = D && D.__createBinding || (Object.create ? function(n, i, o, l) {
    l === void 0 && (l = o);
    var a = Object.getOwnPropertyDescriptor(i, o);
    (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, l, a);
  } : function(n, i, o, l) {
    l === void 0 && (l = o), n[l] = i[o];
  }), t = D && D.__exportStar || function(n, i) {
    for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.hasChildren = r.isDocument = r.isComment = r.isText = r.isCDATA = r.isTag = void 0, t(Te, r), t(he, r), t(Ae, r), t(ve, r), t(we, r), t(Ce, r), t(Du, r);
  var u = ye;
  Object.defineProperty(r, "isTag", { enumerable: !0, get: function() {
    return u.isTag;
  } }), Object.defineProperty(r, "isCDATA", { enumerable: !0, get: function() {
    return u.isCDATA;
  } }), Object.defineProperty(r, "isText", { enumerable: !0, get: function() {
    return u.isText;
  } }), Object.defineProperty(r, "isComment", { enumerable: !0, get: function() {
    return u.isComment;
  } }), Object.defineProperty(r, "isDocument", { enumerable: !0, get: function() {
    return u.isDocument;
  } }), Object.defineProperty(r, "hasChildren", { enumerable: !0, get: function() {
    return u.hasChildren;
  } });
})(_t);
(function(r) {
  var e = D && D.__createBinding || (Object.create ? function(T, P, N, R) {
    R === void 0 && (R = N);
    var F = Object.getOwnPropertyDescriptor(P, N);
    (!F || ("get" in F ? !P.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return P[N];
    } }), Object.defineProperty(T, R, F);
  } : function(T, P, N, R) {
    R === void 0 && (R = N), T[R] = P[N];
  }), t = D && D.__setModuleDefault || (Object.create ? function(T, P) {
    Object.defineProperty(T, "default", { enumerable: !0, value: P });
  } : function(T, P) {
    T.default = P;
  }), u = D && D.__importStar || function(T) {
    if (T && T.__esModule) return T;
    var P = {};
    if (T != null) for (var N in T) N !== "default" && Object.prototype.hasOwnProperty.call(T, N) && e(P, T, N);
    return t(P, T), P;
  }, n = D && D.__importDefault || function(T) {
    return T && T.__esModule ? T : { default: T };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomUtils = r.parseFeed = r.getFeed = r.ElementType = r.Tokenizer = r.createDomStream = r.parseDOM = r.parseDocument = r.DefaultHandler = r.DomHandler = r.Parser = void 0;
  var i = Ke, o = Ke;
  Object.defineProperty(r, "Parser", { enumerable: !0, get: function() {
    return o.Parser;
  } });
  var l = ye, a = ye;
  Object.defineProperty(r, "DomHandler", { enumerable: !0, get: function() {
    return a.DomHandler;
  } }), Object.defineProperty(r, "DefaultHandler", { enumerable: !0, get: function() {
    return a.DomHandler;
  } });
  function f(T, P) {
    var N = new l.DomHandler(void 0, P);
    return new i.Parser(N, P).end(T), N.root;
  }
  r.parseDocument = f;
  function h(T, P) {
    return f(T, P).children;
  }
  r.parseDOM = h;
  function y(T, P, N) {
    var R = new l.DomHandler(T, P, N);
    return new i.Parser(R, P);
  }
  r.createDomStream = y;
  var s = Au;
  Object.defineProperty(r, "Tokenizer", { enumerable: !0, get: function() {
    return n(s).default;
  } }), r.ElementType = u(ze);
  var c = _t, E = _t;
  Object.defineProperty(r, "getFeed", { enumerable: !0, get: function() {
    return E.getFeed;
  } });
  var _ = { xmlMode: !0 };
  function m(T, P) {
    return P === void 0 && (P = _), (0, c.getFeed)(h(T, P));
  }
  r.parseFeed = m, r.DomUtils = u(_t);
})(Br);
var Pa = (r) => {
  if (typeof r != "string")
    throw new TypeError("Expected a string");
  return r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, Lu = {};
Object.defineProperty(Lu, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function br(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function Ra(r) {
  var e, t;
  return br(r) === !1 ? !1 : (e = r.constructor, e === void 0 ? !0 : (t = e.prototype, !(br(t) === !1 || t.hasOwnProperty("isPrototypeOf") === !1)));
}
Lu.isPlainObject = Ra;
var Da = function(e) {
  return La(e) && !Ma(e);
};
function La(r) {
  return !!r && typeof r == "object";
}
function Ma(r) {
  var e = Object.prototype.toString.call(r);
  return e === "[object RegExp]" || e === "[object Date]" || qa(r);
}
var ka = typeof Symbol == "function" && Symbol.for, ja = ka ? Symbol.for("react.element") : 60103;
function qa(r) {
  return r.$$typeof === ja;
}
function Ba(r) {
  return Array.isArray(r) ? [] : {};
}
function tt(r, e) {
  return e.clone !== !1 && e.isMergeableObject(r) ? $e(Ba(r), r, e) : r;
}
function $a(r, e, t) {
  return r.concat(e).map(function(u) {
    return tt(u, t);
  });
}
function Ua(r, e) {
  if (!e.customMerge)
    return $e;
  var t = e.customMerge(r);
  return typeof t == "function" ? t : $e;
}
function Fa(r) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r).filter(function(e) {
    return Object.propertyIsEnumerable.call(r, e);
  }) : [];
}
function mr(r) {
  return Object.keys(r).concat(Fa(r));
}
function dn(r, e) {
  try {
    return e in r;
  } catch {
    return !1;
  }
}
function Ha(r, e) {
  return dn(r, e) && !(Object.hasOwnProperty.call(r, e) && Object.propertyIsEnumerable.call(r, e));
}
function Va(r, e, t) {
  var u = {};
  return t.isMergeableObject(r) && mr(r).forEach(function(n) {
    u[n] = tt(r[n], t);
  }), mr(e).forEach(function(n) {
    Ha(r, n) || (dn(r, n) && t.isMergeableObject(e[n]) ? u[n] = Ua(n, t)(r[n], e[n], t) : u[n] = tt(e[n], t));
  }), u;
}
function $e(r, e, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || $a, t.isMergeableObject = t.isMergeableObject || Da, t.cloneUnlessOtherwiseSpecified = tt;
  var u = Array.isArray(e), n = Array.isArray(r), i = u === n;
  return i ? u ? t.arrayMerge(r, e, t) : Va(r, e, t) : tt(e, t);
}
$e.all = function(e, t) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(u, n) {
    return $e(u, n, t);
  }, {});
};
var za = $e, Ga = za, hn = { exports: {} };
(function(r) {
  (function(e, t) {
    r.exports ? r.exports = t() : e.parseSrcset = t();
  })(D, function() {
    return function(e) {
      function t(R) {
        return R === " " || // space
        R === "	" || // horizontal tab
        R === `
` || // new line
        R === "\f" || // form feed
        R === "\r";
      }
      function u(R) {
        var F, K = R.exec(e.substring(m));
        if (K)
          return F = K[0], m += F.length, F;
      }
      for (var n = e.length, i = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, l = /^[^ \t\n\r\u000c]+/, a = /[,]+$/, f = /^\d+$/, h = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, y, s, c, E, _, m = 0, T = []; ; ) {
        if (u(o), m >= n)
          return T;
        y = u(l), s = [], y.slice(-1) === "," ? (y = y.replace(a, ""), N()) : P();
      }
      function P() {
        for (u(i), c = "", E = "in descriptor"; ; ) {
          if (_ = e.charAt(m), E === "in descriptor")
            if (t(_))
              c && (s.push(c), c = "", E = "after descriptor");
            else if (_ === ",") {
              m += 1, c && s.push(c), N();
              return;
            } else if (_ === "(")
              c = c + _, E = "in parens";
            else if (_ === "") {
              c && s.push(c), N();
              return;
            } else
              c = c + _;
          else if (E === "in parens")
            if (_ === ")")
              c = c + _, E = "in descriptor";
            else if (_ === "") {
              s.push(c), N();
              return;
            } else
              c = c + _;
          else if (E === "after descriptor" && !t(_))
            if (_ === "") {
              N();
              return;
            } else
              E = "in descriptor", m -= 1;
          m += 1;
        }
      }
      function N() {
        var R = !1, F, K, Q, k, ue = {}, Z, b, w, S, I;
        for (k = 0; k < s.length; k++)
          Z = s[k], b = Z[Z.length - 1], w = Z.substring(0, Z.length - 1), S = parseInt(w, 10), I = parseFloat(w), f.test(w) && b === "w" ? ((F || K) && (R = !0), S === 0 ? R = !0 : F = S) : h.test(w) && b === "x" ? ((F || K || Q) && (R = !0), I < 0 ? R = !0 : K = I) : f.test(w) && b === "h" ? ((Q || K) && (R = !0), S === 0 ? R = !0 : Q = S) : R = !0;
        R ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + Z + "'.") : (ue.url = y, F && (ue.w = F), K && (ue.d = K), Q && (ue.h = Q), T.push(ue));
      }
    };
  });
})(hn);
var Wa = hn.exports, Mu = { exports: {} }, M = String, pn = function() {
  return { isColorSupported: !1, reset: M, bold: M, dim: M, italic: M, underline: M, inverse: M, hidden: M, strikethrough: M, black: M, red: M, green: M, yellow: M, blue: M, magenta: M, cyan: M, white: M, gray: M, bgBlack: M, bgRed: M, bgGreen: M, bgYellow: M, bgBlue: M, bgMagenta: M, bgCyan: M, bgWhite: M, blackBright: M, redBright: M, greenBright: M, yellowBright: M, blueBright: M, magentaBright: M, cyanBright: M, whiteBright: M, bgBlackBright: M, bgRedBright: M, bgGreenBright: M, bgYellowBright: M, bgBlueBright: M, bgMagentaBright: M, bgCyanBright: M, bgWhiteBright: M };
};
Mu.exports = pn();
Mu.exports.createColors = pn;
var Ya = Mu.exports;
const Xa = {}, Ja = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xa
}, Symbol.toStringTag, { value: "Module" })), le = /* @__PURE__ */ wi(Ja);
let gr = Ya, yr = le, lu = class bn extends Error {
  constructor(e, t, u, n, i, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, i && (this.file = i), n && (this.source = n), o && (this.plugin = o), typeof t < "u" && typeof u < "u" && (typeof t == "number" ? (this.line = t, this.column = u) : (this.line = t.line, this.column = t.column, this.endLine = u.line, this.endColumn = u.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, bn);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = gr.isColorSupported);
    let u = (h) => h, n = (h) => h, i = (h) => h;
    if (e) {
      let { bold: h, gray: y, red: s } = gr.createColors(!0);
      n = (c) => h(s(c)), u = (c) => y(c), yr && (i = (c) => yr(c));
    }
    let o = t.split(/\r?\n/), l = Math.max(this.line - 3, 0), a = Math.min(this.line + 2, o.length), f = String(a).length;
    return o.slice(l, a).map((h, y) => {
      let s = l + 1 + y, c = " " + (" " + s).slice(-f) + " | ";
      if (s === this.line) {
        if (h.length > 160) {
          let _ = 20, m = Math.max(0, this.column - _), T = Math.max(
            this.column + _,
            this.endColumn + _
          ), P = h.slice(m, T), N = u(c.replace(/\d/g, " ")) + h.slice(0, Math.min(this.column - 1, _ - 1)).replace(/[^\t]/g, " ");
          return n(">") + u(c) + i(P) + `
 ` + N + n("^");
        }
        let E = u(c.replace(/\d/g, " ")) + h.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return n(">") + u(c) + i(h) + `
 ` + E + n("^");
      }
      return " " + u(c) + i(h);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var ku = lu;
lu.default = lu;
const xr = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function Za(r) {
  return r[0].toUpperCase() + r.slice(1);
}
let fu = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let u = "@" + e.name, n = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? u += e.raws.afterName : n && (u += " "), e.nodes)
      this.block(e, u + n);
    else {
      let i = (e.raws.between || "") + (t ? ";" : "");
      this.builder(u + n + i, e);
    }
  }
  beforeAfter(e, t) {
    let u;
    e.type === "decl" ? u = this.raw(e, null, "beforeDecl") : e.type === "comment" ? u = this.raw(e, null, "beforeComment") : t === "before" ? u = this.raw(e, null, "beforeRule") : u = this.raw(e, null, "beforeClose");
    let n = e.parent, i = 0;
    for (; n && n.type !== "root"; )
      i += 1, n = n.parent;
    if (u.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let l = 0; l < i; l++) u += o;
    }
    return u;
  }
  block(e, t) {
    let u = this.raw(e, "between", "beforeOpen");
    this.builder(t + u + "{", e, "start");
    let n;
    e.nodes && e.nodes.length ? (this.body(e), n = this.raw(e, "after")) : n = this.raw(e, "after", "emptyBody"), n && this.builder(n), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let u = this.raw(e, "semicolon");
    for (let n = 0; n < e.nodes.length; n++) {
      let i = e.nodes[n], o = this.raw(i, "before");
      o && this.builder(o), this.stringify(i, t !== n || u);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), u = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + u + "*/", e);
  }
  decl(e, t) {
    let u = this.raw(e, "between", "colon"), n = e.prop + u + this.rawValue(e, "value");
    e.important && (n += e.raws.important || " !important"), t && (n += ";"), this.builder(n, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, u) {
    let n;
    if (u || (u = t), t && (n = e.raws[t], typeof n < "u"))
      return n;
    let i = e.parent;
    if (u === "before" && (!i || i.type === "root" && i.first === e || i && i.type === "document"))
      return "";
    if (!i) return xr[u];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[u] < "u")
      return o.rawCache[u];
    if (u === "before" || u === "after")
      return this.beforeAfter(e, u);
    {
      let l = "raw" + Za(u);
      this[l] ? n = this[l](o, e) : o.walk((a) => {
        if (n = a.raws[t], typeof n < "u") return !1;
      });
    }
    return typeof n > "u" && (n = xr[u]), o.rawCache[u] = n, n;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length > 0 && typeof u.raws.after < "u")
        return t = u.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let u;
    return e.walkComments((n) => {
      if (typeof n.raws.before < "u")
        return u = n.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(t, null, "beforeDecl") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeDecl(e, t) {
    let u;
    return e.walkDecls((n) => {
      if (typeof n.raws.before < "u")
        return u = n.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(t, null, "beforeRule") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((u) => {
      if (u.type !== "decl" && (t = u.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && (u.parent !== e || e.first !== u) && typeof u.raws.before < "u")
        return t = u.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((u) => {
      if (typeof u.raws.between < "u")
        return t = u.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length === 0 && (t = u.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((u) => {
      let n = u.parent;
      if (n && n !== e && n.parent && n.parent === e && typeof u.raws.before < "u") {
        let i = u.raws.before.split(`
`);
        return t = i[i.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length && u.last.type === "decl" && (t = u.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let u = e[t], n = e.raws[t];
    return n && n.value === u ? n.raw : u;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var mn = fu;
fu.default = fu;
let Qa = mn;
function du(r, e) {
  new Qa(e).stringify(r);
}
var Ft = du;
du.default = du;
var ft = {};
ft.isClean = Symbol("isClean");
ft.my = Symbol("my");
let Ka = ku, e0 = mn, t0 = Ft, { isClean: Ye, my: u0 } = ft;
function hu(r, e) {
  let t = new r.constructor();
  for (let u in r) {
    if (!Object.prototype.hasOwnProperty.call(r, u) || u === "proxyCache") continue;
    let n = r[u], i = typeof n;
    u === "parent" && i === "object" ? e && (t[u] = e) : u === "source" ? t[u] = n : Array.isArray(n) ? t[u] = n.map((o) => hu(o, t)) : (i === "object" && n !== null && (n = hu(n)), t[u] = n);
  }
  return t;
}
function Xe(r, e) {
  if (e && typeof e.offset < "u")
    return e.offset;
  let t = 1, u = 1, n = 0;
  for (let i = 0; i < r.length; i++) {
    if (u === e.line && t === e.column) {
      n = i;
      break;
    }
    r[i] === `
` ? (t = 1, u += 1) : t += 1;
  }
  return n;
}
let pu = class {
  constructor(e = {}) {
    this.raws = {}, this[Ye] = !1, this[u0] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let u of e[t])
          typeof u.clone == "function" ? this.append(u.clone()) : this.append(u);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = hu(this);
    for (let u in e)
      t[u] = e[u];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: u, start: n } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: n.column, line: n.line },
        { column: u.column, line: u.line },
        t
      );
    }
    return new Ka(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, u) {
        return e[t] === u || (e[t] = u, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Ye] = !0;
  }
  markDirty() {
    if (this[Ye]) {
      this[Ye] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Ye] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = u.slice(
        Xe(u, this.source.start),
        Xe(u, this.source.end)
      ).indexOf(e.word);
      i !== -1 && (t = this.positionInside(i));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, u = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = Xe(n, this.source.start), o = i + e;
    for (let l = i; l < o; l++)
      n[l] === `
` ? (t = 1, u += 1) : t += 1;
    return { column: t, line: u };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, u = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = n.slice(
        Xe(n, this.source.start),
        Xe(n, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), u = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? u = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? u = this.positionInside(e.endIndex) : e.index && (u = this.positionInside(e.index + 1));
    return (u.line < t.line || u.line === t.line && u.column <= t.column) && (u = { column: t.column + 1, line: t.line }), { end: u, start: t };
  }
  raw(e, t) {
    return new e0().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, u = !1;
      for (let n of e)
        n === this ? u = !0 : u ? (this.parent.insertAfter(t, n), t = n) : this.parent.insertBefore(t, n);
      u || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let u = {}, n = t == null;
    t = t || /* @__PURE__ */ new Map();
    let i = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let l = this[o];
      if (Array.isArray(l))
        u[o] = l.map((a) => typeof a == "object" && a.toJSON ? a.toJSON(null, t) : a);
      else if (typeof l == "object" && l.toJSON)
        u[o] = l.toJSON(null, t);
      else if (o === "source") {
        let a = t.get(l.input);
        a == null && (a = i, t.set(l.input, i), i++), u[o] = {
          end: l.end,
          inputId: a,
          start: l.start
        };
      } else
        u[o] = l;
    }
    return n && (u.inputs = [...t.keys()].map((o) => o.toJSON())), u;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = t0) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (u) => {
      t += u;
    }), t;
  }
  warn(e, t, u) {
    let n = { node: this };
    for (let i in u) n[i] = u[i];
    return e.warn(t, n);
  }
  get proxyOf() {
    return this;
  }
};
var Ht = pu;
pu.default = pu;
let r0 = Ht, bu = class extends r0 {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Vt = bu;
bu.default = bu;
let n0 = Ht, mu = class extends n0 {
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
};
var zt = mu;
mu.default = mu;
let gn = Vt, yn = zt, i0 = Ht, { isClean: xn, my: vn } = ft, ju, wn, En, qu;
function Sn(r) {
  return r.map((e) => (e.nodes && (e.nodes = Sn(e.nodes)), delete e.source, e));
}
function Tn(r) {
  if (r[xn] = !1, r.proxyOf.nodes)
    for (let e of r.proxyOf.nodes)
      Tn(e);
}
let xe = class An extends i0 {
  append(...e) {
    for (let t of e) {
      let u = this.normalize(t, this.last);
      for (let n of u) this.proxyOf.nodes.push(n);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), u, n;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (u = this.indexes[t], n = e(this.proxyOf.nodes[u], u), n !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], n;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...u) => e[t](
          ...u.map((n) => typeof n == "function" ? (i, o) => n(i.toProxy(), o) : n)
        ) : t === "every" || t === "some" ? (u) => e[t](
          (n, ...i) => u(n.toProxy(), ...i)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((u) => u.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, u) {
        return e[t] === u || (e[t] = u, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let u = this.index(e), n = this.normalize(t, this.proxyOf.nodes[u]).reverse();
    u = this.index(e);
    for (let o of n) this.proxyOf.nodes.splice(u + 1, 0, o);
    let i;
    for (let o in this.indexes)
      i = this.indexes[o], u < i && (this.indexes[o] = i + n.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let u = this.index(e), n = u === 0 ? "prepend" : !1, i = this.normalize(
      t,
      this.proxyOf.nodes[u],
      n
    ).reverse();
    u = this.index(e);
    for (let l of i) this.proxyOf.nodes.splice(u, 0, l);
    let o;
    for (let l in this.indexes)
      o = this.indexes[l], u <= o && (this.indexes[l] = o + i.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Sn(wn(e).nodes);
    else if (typeof e > "u")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let n of e)
        n.parent && n.parent.removeChild(n, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let n of e)
        n.parent && n.parent.removeChild(n, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new yn(e)];
    } else if (e.selector || e.selectors)
      e = [new qu(e)];
    else if (e.name)
      e = [new ju(e)];
    else if (e.text)
      e = [new gn(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((n) => (n[vn] || An.rebuild(n), n = n.proxyOf, n.parent && n.parent.removeChild(n), n[xn] && Tn(n), n.raws || (n.raws = {}), typeof n.raws.before > "u" && t && typeof t.raws.before < "u" && (n.raws.before = t.raws.before.replace(/\S/g, "")), n.parent = this.proxyOf, n));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let u = this.normalize(t, this.first, "prepend").reverse();
      for (let n of u) this.proxyOf.nodes.unshift(n);
      for (let n in this.indexes)
        this.indexes[n] = this.indexes[n] + u.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let u in this.indexes)
      t = this.indexes[u], t >= e && (this.indexes[u] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, u) {
    return u || (u = t, t = {}), this.walkDecls((n) => {
      t.props && !t.props.includes(n.prop) || t.fast && !n.value.includes(t.fast) || (n.value = n.value.replace(e, u));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, u) => {
      let n;
      try {
        n = e(t, u);
      } catch (i) {
        throw t.addToError(i);
      }
      return n !== !1 && t.walk && (n = t.walk(e)), n;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "atrule" && e.test(u.name))
        return t(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "atrule" && u.name === e)
        return t(u, n);
    }) : (t = e, this.walk((u, n) => {
      if (u.type === "atrule")
        return t(u, n);
    }));
  }
  walkComments(e) {
    return this.walk((t, u) => {
      if (t.type === "comment")
        return e(t, u);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "decl" && e.test(u.prop))
        return t(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "decl" && u.prop === e)
        return t(u, n);
    }) : (t = e, this.walk((u, n) => {
      if (u.type === "decl")
        return t(u, n);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, n) => {
      if (u.type === "rule" && e.test(u.selector))
        return t(u, n);
    }) : this.walk((u, n) => {
      if (u.type === "rule" && u.selector === e)
        return t(u, n);
    }) : (t = e, this.walk((u, n) => {
      if (u.type === "rule")
        return t(u, n);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
};
xe.registerParse = (r) => {
  wn = r;
};
xe.registerRule = (r) => {
  qu = r;
};
xe.registerAtRule = (r) => {
  ju = r;
};
xe.registerRoot = (r) => {
  En = r;
};
var Ie = xe;
xe.default = xe;
xe.rebuild = (r) => {
  r.type === "atrule" ? Object.setPrototypeOf(r, ju.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, qu.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, yn.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, gn.prototype) : r.type === "root" && Object.setPrototypeOf(r, En.prototype), r[vn] = !0, r.nodes && r.nodes.forEach((e) => {
    xe.rebuild(e);
  });
};
let _n = Ie, Lt = class extends _n {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Bu = Lt;
Lt.default = Lt;
_n.registerAtRule(Lt);
let a0 = Ie, On, Nn, ut = class extends a0 {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new On(new Nn(), this, e).stringify();
  }
};
ut.registerLazyResult = (r) => {
  On = r;
};
ut.registerProcessor = (r) => {
  Nn = r;
};
var $u = ut;
ut.default = ut;
let s0 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", o0 = (r, e = 21) => (t = e) => {
  let u = "", n = t | 0;
  for (; n--; )
    u += r[Math.random() * r.length | 0];
  return u;
}, c0 = (r = 21) => {
  let e = "", t = r | 0;
  for (; t--; )
    e += s0[Math.random() * 64 | 0];
  return e;
};
var l0 = { nanoid: c0, customAlphabet: o0 };
let { existsSync: f0, readFileSync: d0 } = le, { dirname: uu, join: h0 } = le, { SourceMapConsumer: vr, SourceMapGenerator: wr } = le;
function p0(r) {
  return Buffer ? Buffer.from(r, "base64").toString() : window.atob(r);
}
let gu = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let u = t.map ? t.map.prev : void 0, n = this.loadMap(t.from, u);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = uu(this.mapFile)), n && (this.text = n);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new vr(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, u = /^data:application\/json;base64,/, n = /^data:application\/json;charset=utf-?8,/, i = /^data:application\/json,/, o = e.match(n) || e.match(i);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let l = e.match(t) || e.match(u);
    if (l)
      return p0(e.substr(l[0].length));
    let a = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + a);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let u = e.lastIndexOf(t.pop()), n = e.indexOf("*/", u);
    u > -1 && n > -1 && (this.annotation = this.getAnnotationURL(e.substring(u, n)));
  }
  loadFile(e) {
    if (this.root = uu(e), f0(e))
      return this.mapFile = e, d0(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let u = t(e);
        if (u) {
          let n = this.loadFile(u);
          if (!n)
            throw new Error(
              "Unable to load previous source map: " + u.toString()
            );
          return n;
        }
      } else {
        if (t instanceof vr)
          return wr.fromSourceMap(t).toString();
        if (t instanceof wr)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let u = this.annotation;
        return e && (u = h0(uu(e), u)), this.loadFile(u);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Cn = gu;
gu.default = gu;
let { nanoid: b0 } = l0, { isAbsolute: yu, resolve: xu } = le, { SourceMapConsumer: m0, SourceMapGenerator: g0 } = le, { fileURLToPath: Er, pathToFileURL: yt } = le, Sr = ku, y0 = Cn, ru = le, nu = Symbol("fromOffsetCache"), x0 = !!(m0 && g0), Tr = !!(xu && yu), Mt = class {
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!Tr || /^\w+:\/\//.test(t.from) || yu(t.from) ? this.file = t.from : this.file = xu(t.from)), Tr && x0) {
      let u = new y0(this.css, t);
      if (u.text) {
        this.map = u;
        let n = u.consumer().file;
        !this.file && n && (this.file = this.mapResolve(n));
      }
    }
    this.file || (this.id = "<input css " + b0(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, u, n = {}) {
    let i, o, l;
    if (t && typeof t == "object") {
      let f = t, h = u;
      if (typeof f.offset == "number") {
        let y = this.fromOffset(f.offset);
        t = y.line, u = y.col;
      } else
        t = f.line, u = f.column;
      if (typeof h.offset == "number") {
        let y = this.fromOffset(h.offset);
        o = y.line, i = y.col;
      } else
        o = h.line, i = h.column;
    } else if (!u) {
      let f = this.fromOffset(t);
      t = f.line, u = f.col;
    }
    let a = this.origin(t, u, o, i);
    return a ? l = new Sr(
      e,
      a.endLine === void 0 ? a.line : { column: a.column, line: a.line },
      a.endLine === void 0 ? a.column : { column: a.endColumn, line: a.endLine },
      a.source,
      a.file,
      n.plugin
    ) : l = new Sr(
      e,
      o === void 0 ? t : { column: u, line: t },
      o === void 0 ? u : { column: i, line: o },
      this.css,
      this.file,
      n.plugin
    ), l.input = { column: u, endColumn: i, endLine: o, line: t, source: this.css }, this.file && (yt && (l.input.url = yt(this.file).toString()), l.input.file = this.file), l;
  }
  fromOffset(e) {
    let t, u;
    if (this[nu])
      u = this[nu];
    else {
      let i = this.css.split(`
`);
      u = new Array(i.length);
      let o = 0;
      for (let l = 0, a = i.length; l < a; l++)
        u[l] = o, o += i[l].length + 1;
      this[nu] = u;
    }
    t = u[u.length - 1];
    let n = 0;
    if (e >= t)
      n = u.length - 1;
    else {
      let i = u.length - 2, o;
      for (; n < i; )
        if (o = n + (i - n >> 1), e < u[o])
          i = o - 1;
        else if (e >= u[o + 1])
          n = o + 1;
        else {
          n = o;
          break;
        }
    }
    return {
      col: e - u[n] + 1,
      line: n + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : xu(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, u, n) {
    if (!this.map) return !1;
    let i = this.map.consumer(), o = i.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let l;
    typeof u == "number" && (l = i.originalPositionFor({ column: n, line: u }));
    let a;
    yu(o.source) ? a = yt(o.source) : a = new URL(
      o.source,
      this.map.consumer().sourceRoot || yt(this.map.mapFile)
    );
    let f = {
      column: o.column,
      endColumn: l && l.column,
      endLine: l && l.line,
      line: o.line,
      url: a.toString()
    };
    if (a.protocol === "file:")
      if (Er)
        f.file = Er(a);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let h = i.sourceContentFor(o.source);
    return h && (f.source = h), f;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
  get from() {
    return this.file || this.id;
  }
};
var Gt = Mt;
Mt.default = Mt;
ru && ru.registerInput && ru.registerInput(Mt);
let In = Ie, Pn, Rn, Ue = class extends In {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, u) {
    let n = super.normalize(e);
    if (t) {
      if (u === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let i of n)
          i.raws.before = t.raws.before;
    }
    return n;
  }
  removeChild(e, t) {
    let u = this.index(e);
    return !t && u === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[u].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Pn(new Rn(), this, e).stringify();
  }
};
Ue.registerLazyResult = (r) => {
  Pn = r;
};
Ue.registerProcessor = (r) => {
  Rn = r;
};
var dt = Ue;
Ue.default = Ue;
In.registerRoot(Ue);
let rt = {
  comma(r) {
    return rt.split(r, [","], !0);
  },
  space(r) {
    let e = [" ", `
`, "	"];
    return rt.split(r, e);
  },
  split(r, e, t) {
    let u = [], n = "", i = !1, o = 0, l = !1, a = "", f = !1;
    for (let h of r)
      f ? f = !1 : h === "\\" ? f = !0 : l ? h === a && (l = !1) : h === '"' || h === "'" ? (l = !0, a = h) : h === "(" ? o += 1 : h === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(h) && (i = !0), i ? (n !== "" && u.push(n.trim()), n = "", i = !1) : n += h;
    return (t || n !== "") && u.push(n.trim()), u;
  }
};
var Dn = rt;
rt.default = rt;
let Ln = Ie, v0 = Dn, kt = class extends Ln {
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return v0.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, u = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(u);
  }
};
var Uu = kt;
kt.default = kt;
Ln.registerRule(kt);
let w0 = Bu, E0 = Vt, S0 = zt, T0 = Gt, A0 = Cn, _0 = dt, O0 = Uu;
function nt(r, e) {
  if (Array.isArray(r)) return r.map((n) => nt(n));
  let { inputs: t, ...u } = r;
  if (t) {
    e = [];
    for (let n of t) {
      let i = { ...n, __proto__: T0.prototype };
      i.map && (i.map = {
        ...i.map,
        __proto__: A0.prototype
      }), e.push(i);
    }
  }
  if (u.nodes && (u.nodes = r.nodes.map((n) => nt(n, e))), u.source) {
    let { inputId: n, ...i } = u.source;
    u.source = i, n != null && (u.source.input = e[n]);
  }
  if (u.type === "root")
    return new _0(u);
  if (u.type === "decl")
    return new S0(u);
  if (u.type === "rule")
    return new O0(u);
  if (u.type === "comment")
    return new E0(u);
  if (u.type === "atrule")
    return new w0(u);
  throw new Error("Unknown node type: " + r.type);
}
var N0 = nt;
nt.default = nt;
let { dirname: Nt, relative: Mn, resolve: kn, sep: jn } = le, { SourceMapConsumer: qn, SourceMapGenerator: Ct } = le, { pathToFileURL: Ar } = le, C0 = Gt, I0 = !!(qn && Ct), P0 = !!(Nt && kn && Mn && jn), R0 = class {
  constructor(e, t, u, n) {
    this.stringify = e, this.mapOpts = u.map || {}, this.root = t, this.opts = u, this.css = n, this.originalCSS = n, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), u = e.root || Nt(e.file), n;
      this.mapOpts.sourcesContent === !1 ? (n = new qn(e.text), n.sourcesContent && (n.sourcesContent = null)) : n = e.consumer(), this.map.applySourceMap(n, t, this.toUrl(this.path(u)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), P0 && I0 && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Ct.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Ct({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Ct({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, u = "<no source>", n = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, i, o;
    this.stringify(this.root, (l, a, f) => {
      if (this.css += l, a && f !== "end" && (n.generated.line = e, n.generated.column = t - 1, a.source && a.source.start ? (n.source = this.sourcePath(a), n.original.line = a.source.start.line, n.original.column = a.source.start.column - 1, this.map.addMapping(n)) : (n.source = u, n.original.line = 1, n.original.column = 0, this.map.addMapping(n))), o = l.match(/\n/g), o ? (e += o.length, i = l.lastIndexOf(`
`), t = l.length - i) : t += l.length, a && f !== "start") {
        let h = a.parent || { raws: {} };
        (!(a.type === "decl" || a.type === "atrule" && !a.nodes) || a !== h.last || h.raws.semicolon) && (a.source && a.source.end ? (n.source = this.sourcePath(a), n.original.line = a.source.end.line, n.original.column = a.source.end.column - 1, n.generated.line = e, n.generated.column = t - 2, this.map.addMapping(n)) : (n.source = u, n.original.line = 1, n.original.column = 0, n.generated.line = e, n.generated.column = t - 1, this.map.addMapping(n)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let u = this.opts.to ? Nt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (u = Nt(kn(u, this.mapOpts.annotation)));
    let n = Mn(u, e);
    return this.memoizedPaths.set(e, n), n;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new C0(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let u = t.source.input.from;
          if (u && !e[u]) {
            e[u] = !0;
            let n = this.usesFileUrls ? this.toFileUrl(u) : this.toUrl(this.path(u));
            this.map.setSourceContent(n, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (Ar) {
      let u = Ar(e).toString();
      return this.memoizedFileURLs.set(e, u), u;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    jn === "\\" && (e = e.replace(/\\/g, "/"));
    let u = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, u), u;
  }
};
var Bn = R0;
const iu = 39, _r = 34, xt = 92, Or = 47, vt = 10, Je = 32, wt = 12, Et = 9, St = 13, D0 = 91, L0 = 93, M0 = 40, k0 = 41, j0 = 123, q0 = 125, B0 = 59, $0 = 42, U0 = 58, F0 = 64, Tt = /[\t\n\f\r "#'()/;[\\\]{}]/g, At = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, H0 = /.[\r\n"'(/\\]/, Nr = /[\da-f]/i;
var V0 = function(e, t = {}) {
  let u = e.css.valueOf(), n = t.ignoreErrors, i, o, l, a, f, h, y, s, c, E, _ = u.length, m = 0, T = [], P = [];
  function N() {
    return m;
  }
  function R(k) {
    throw e.error("Unclosed " + k, m);
  }
  function F() {
    return P.length === 0 && m >= _;
  }
  function K(k) {
    if (P.length) return P.pop();
    if (m >= _) return;
    let ue = k ? k.ignoreUnclosed : !1;
    switch (i = u.charCodeAt(m), i) {
      case vt:
      case Je:
      case Et:
      case St:
      case wt: {
        a = m;
        do
          a += 1, i = u.charCodeAt(a);
        while (i === Je || i === vt || i === Et || i === St || i === wt);
        h = ["space", u.slice(m, a)], m = a - 1;
        break;
      }
      case D0:
      case L0:
      case j0:
      case q0:
      case U0:
      case B0:
      case k0: {
        let Z = String.fromCharCode(i);
        h = [Z, Z, m];
        break;
      }
      case M0: {
        if (E = T.length ? T.pop()[1] : "", c = u.charCodeAt(m + 1), E === "url" && c !== iu && c !== _r && c !== Je && c !== vt && c !== Et && c !== wt && c !== St) {
          a = m;
          do {
            if (y = !1, a = u.indexOf(")", a + 1), a === -1)
              if (n || ue) {
                a = m;
                break;
              } else
                R("bracket");
            for (s = a; u.charCodeAt(s - 1) === xt; )
              s -= 1, y = !y;
          } while (y);
          h = ["brackets", u.slice(m, a + 1), m, a], m = a;
        } else
          a = u.indexOf(")", m + 1), o = u.slice(m, a + 1), a === -1 || H0.test(o) ? h = ["(", "(", m] : (h = ["brackets", o, m, a], m = a);
        break;
      }
      case iu:
      case _r: {
        f = i === iu ? "'" : '"', a = m;
        do {
          if (y = !1, a = u.indexOf(f, a + 1), a === -1)
            if (n || ue) {
              a = m + 1;
              break;
            } else
              R("string");
          for (s = a; u.charCodeAt(s - 1) === xt; )
            s -= 1, y = !y;
        } while (y);
        h = ["string", u.slice(m, a + 1), m, a], m = a;
        break;
      }
      case F0: {
        Tt.lastIndex = m + 1, Tt.test(u), Tt.lastIndex === 0 ? a = u.length - 1 : a = Tt.lastIndex - 2, h = ["at-word", u.slice(m, a + 1), m, a], m = a;
        break;
      }
      case xt: {
        for (a = m, l = !0; u.charCodeAt(a + 1) === xt; )
          a += 1, l = !l;
        if (i = u.charCodeAt(a + 1), l && i !== Or && i !== Je && i !== vt && i !== Et && i !== St && i !== wt && (a += 1, Nr.test(u.charAt(a)))) {
          for (; Nr.test(u.charAt(a + 1)); )
            a += 1;
          u.charCodeAt(a + 1) === Je && (a += 1);
        }
        h = ["word", u.slice(m, a + 1), m, a], m = a;
        break;
      }
      default: {
        i === Or && u.charCodeAt(m + 1) === $0 ? (a = u.indexOf("*/", m + 2) + 1, a === 0 && (n || ue ? a = u.length : R("comment")), h = ["comment", u.slice(m, a + 1), m, a], m = a) : (At.lastIndex = m + 1, At.test(u), At.lastIndex === 0 ? a = u.length - 1 : a = At.lastIndex - 2, h = ["word", u.slice(m, a + 1), m, a], T.push(h), m = a);
        break;
      }
    }
    return m++, h;
  }
  function Q(k) {
    P.push(k);
  }
  return {
    back: Q,
    endOfFile: F,
    nextToken: K,
    position: N
  };
};
let z0 = Bu, G0 = Vt, W0 = zt, Y0 = dt, Cr = Uu, X0 = V0;
const Ir = {
  empty: !0,
  space: !0
};
function J0(r) {
  for (let e = r.length - 1; e >= 0; e--) {
    let t = r[e], u = t[3] || t[2];
    if (u) return u;
  }
}
let Z0 = class {
  constructor(e) {
    this.input = e, this.root = new Y0(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new z0();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let u, n, i, o = !1, l = !1, a = [], f = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), u = e[0], u === "(" || u === "[" ? f.push(u === "(" ? ")" : "]") : u === "{" && f.length > 0 ? f.push("}") : u === f[f.length - 1] && f.pop(), f.length === 0)
        if (u === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (u === "{") {
          l = !0;
          break;
        } else if (u === "}") {
          if (a.length > 0) {
            for (i = a.length - 1, n = a[i]; n && n[0] === "space"; )
              n = a[--i];
            n && (t.source.end = this.getPosition(n[3] || n[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          a.push(e);
      else
        a.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(a), a.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(a), this.raw(t, "params", a), o && (e = a[a.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), l && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let u = 0, n;
    for (let i = t - 1; i >= 0 && (n = e[i], !(n[0] !== "space" && (u += 1, u === 2))); i--)
      ;
    throw this.input.error(
      "Missed semicolon",
      n[0] === "word" ? n[3] + 1 : n[2]
    );
  }
  colon(e) {
    let t = 0, u, n, i;
    for (let [o, l] of e.entries()) {
      if (n = l, i = n[0], i === "(" && (t += 1), i === ")" && (t -= 1), t === 0 && i === ":")
        if (!u)
          this.doubleColon(n);
        else {
          if (u[0] === "word" && u[1] === "progid")
            continue;
          return o;
        }
      u = n;
    }
    return !1;
  }
  comment(e) {
    let t = new G0();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let u = e[1].slice(2, -2);
    if (/^\s*$/.test(u))
      t.text = "", t.raws.left = u, t.raws.right = "";
    else {
      let n = u.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = n[2], t.raws.left = n[1], t.raws.right = n[3];
    }
  }
  createTokenizer() {
    this.tokenizer = X0(this.input);
  }
  decl(e, t) {
    let u = new W0();
    this.init(u, e[0][2]);
    let n = e[e.length - 1];
    for (n[0] === ";" && (this.semicolon = !0, e.pop()), u.source.end = this.getPosition(
      n[3] || n[2] || J0(e)
    ), u.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), u.raws.before += e.shift()[1];
    for (u.source.start = this.getPosition(e[0][2]), u.prop = ""; e.length; ) {
      let f = e[0][0];
      if (f === ":" || f === "space" || f === "comment")
        break;
      u.prop += e.shift()[1];
    }
    u.raws.between = "";
    let i;
    for (; e.length; )
      if (i = e.shift(), i[0] === ":") {
        u.raws.between += i[1];
        break;
      } else
        i[0] === "word" && /\w/.test(i[1]) && this.unknownWord([i]), u.raws.between += i[1];
    (u.prop[0] === "_" || u.prop[0] === "*") && (u.raws.before += u.prop[0], u.prop = u.prop.slice(1));
    let o = [], l;
    for (; e.length && (l = e[0][0], !(l !== "space" && l !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let f = e.length - 1; f >= 0; f--) {
      if (i = e[f], i[1].toLowerCase() === "!important") {
        u.important = !0;
        let h = this.stringFrom(e, f);
        h = this.spacesFromEnd(e) + h, h !== " !important" && (u.raws.important = h);
        break;
      } else if (i[1].toLowerCase() === "important") {
        let h = e.slice(0), y = "";
        for (let s = f; s > 0; s--) {
          let c = h[s][0];
          if (y.trim().startsWith("!") && c !== "space")
            break;
          y = h.pop()[1] + y;
        }
        y.trim().startsWith("!") && (u.important = !0, u.raws.important = y, e = h);
      }
      if (i[0] !== "space" && i[0] !== "comment")
        break;
    }
    e.some((f) => f[0] !== "space" && f[0] !== "comment") && (u.raws.between += o.map((f) => f[1]).join(""), o = []), this.raw(u, "value", o.concat(e), t), u.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new Cr();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, u = null, n = !1, i = null, o = [], l = e[1].startsWith("--"), a = [], f = e;
    for (; f; ) {
      if (u = f[0], a.push(f), u === "(" || u === "[")
        i || (i = f), o.push(u === "(" ? ")" : "]");
      else if (l && n && u === "{")
        i || (i = f), o.push("}");
      else if (o.length === 0)
        if (u === ";")
          if (n) {
            this.decl(a, l);
            return;
          } else
            break;
        else if (u === "{") {
          this.rule(a);
          return;
        } else if (u === "}") {
          this.tokenizer.back(a.pop()), t = !0;
          break;
        } else u === ":" && (n = !0);
      else u === o[o.length - 1] && (o.pop(), o.length === 0 && (i = null));
      f = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(i), t && n) {
      if (!l)
        for (; a.length && (f = a[a.length - 1][0], !(f !== "space" && f !== "comment")); )
          this.tokenizer.back(a.pop());
      this.decl(a, l);
    } else
      this.unknownWord(a);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, u, n) {
    let i, o, l = u.length, a = "", f = !0, h, y;
    for (let s = 0; s < l; s += 1)
      i = u[s], o = i[0], o === "space" && s === l - 1 && !n ? f = !1 : o === "comment" ? (y = u[s - 1] ? u[s - 1][0] : "empty", h = u[s + 1] ? u[s + 1][0] : "empty", !Ir[y] && !Ir[h] ? a.slice(-1) === "," ? f = !1 : a += i[1] : f = !1) : a += i[1];
    if (!f) {
      let s = u.reduce((c, E) => c + E[1], "");
      e.raws[t] = { raw: s, value: a };
    }
    e[t] = a;
  }
  rule(e) {
    e.pop();
    let t = new Cr();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, u = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      u = e.pop()[1] + u;
    return u;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, u = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      u += e.shift()[1];
    return u;
  }
  spacesFromEnd(e) {
    let t, u = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      u = e.pop()[1] + u;
    return u;
  }
  stringFrom(e, t) {
    let u = "";
    for (let n = t; n < e.length; n++)
      u += e[n][1];
    return e.splice(t, e.length - t), u;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word",
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var Q0 = Z0;
let K0 = Ie, es = Gt, ts = Q0;
function jt(r, e) {
  let t = new es(r, e), u = new ts(t);
  try {
    u.parse();
  } catch (n) {
    throw process.env.NODE_ENV !== "production" && n.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? n.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? n.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (n.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), n;
  }
  return u.root;
}
var Fu = jt;
jt.default = jt;
K0.registerParse(jt);
let vu = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let u = t.node.rangeBy(t);
      this.line = u.start.line, this.column = u.start.column, this.endLine = u.end.line, this.endColumn = u.end.column;
    }
    for (let u in t) this[u] = t[u];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var $n = vu;
vu.default = vu;
let us = $n, wu = class {
  constructor(e, t, u) {
    this.processor = e, this.messages = [], this.root = t, this.opts = u, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let u = new us(e, t);
    return this.messages.push(u), u;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
  get content() {
    return this.css;
  }
};
var Hu = wu;
wu.default = wu;
let Pr = {};
var Un = function(e) {
  Pr[e] || (Pr[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let rs = Ie, ns = $u, is = Bn, as = Fu, Rr = Hu, ss = dt, os = Ft, { isClean: fe, my: cs } = ft, ls = Un;
const fs = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, ds = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, hs = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, Fe = 0;
function Ze(r) {
  return typeof r == "object" && typeof r.then == "function";
}
function Fn(r) {
  let e = !1, t = fs[r.type];
  return r.type === "decl" ? e = r.prop.toLowerCase() : r.type === "atrule" && (e = r.name.toLowerCase()), e && r.append ? [
    t,
    t + "-" + e,
    Fe,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : r.append ? [t, Fe, t + "Exit"] : [t, t + "Exit"];
}
function Dr(r) {
  let e;
  return r.type === "document" ? e = ["Document", Fe, "DocumentExit"] : r.type === "root" ? e = ["Root", Fe, "RootExit"] : e = Fn(r), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: r,
    visitorIndex: 0,
    visitors: []
  };
}
function Eu(r) {
  return r[fe] = !1, r.nodes && r.nodes.forEach((e) => Eu(e)), r;
}
let Su = {}, He = class Hn {
  constructor(e, t, u) {
    this.stringified = !1, this.processed = !1;
    let n;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      n = Eu(t);
    else if (t instanceof Hn || t instanceof Rr)
      n = Eu(t.root), t.map && (typeof u.map > "u" && (u.map = {}), u.map.inline || (u.map.inline = !1), u.map.prev = t.map);
    else {
      let i = as;
      u.syntax && (i = u.syntax.parse), u.parser && (i = u.parser), i.parse && (i = i.parse);
      try {
        n = i(t, u);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      n && !n[cs] && rs.rebuild(n);
    }
    this.result = new Rr(e, n, u), this.helpers = { ...Su, postcss: Su, result: this.result }, this.plugins = this.processor.plugins.map((i) => typeof i == "object" && i.prepare ? { ...i, ...i.prepare(this.result) } : i);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let u = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = u.postcssPlugin, e.setMessage();
      else if (u.postcssVersion && process.env.NODE_ENV !== "production") {
        let n = u.postcssPlugin, i = u.postcssVersion, o = this.result.processor.version, l = i.split("."), a = o.split(".");
        (l[0] !== a[0] || parseInt(l[1]) > parseInt(a[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + n + " uses " + i + ". Perhaps this is the source of the error below."
        );
      }
    } catch (n) {
      console && console.error && console.error(n);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, u, n) => {
      this.listeners[u] || (this.listeners[u] = []), this.listeners[u].push([t, n]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let u in t) {
          if (!ds[u] && /^[A-Z]/.test(u))
            throw new Error(
              `Unknown event ${u} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!hs[u])
            if (typeof t[u] == "object")
              for (let n in t[u])
                n === "*" ? e(t, u, t[u][n]) : e(
                  t,
                  u + "-" + n.toLowerCase(),
                  t[u][n]
                );
            else typeof t[u] == "function" && e(t, u, t[u]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let t = this.plugins[e], u = this.runOnRoot(t);
      if (Ze(u))
        try {
          await u;
        } catch (n) {
          throw this.handleError(n);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[fe]; ) {
        e[fe] = !0;
        let t = [Dr(e)];
        for (; t.length > 0; ) {
          let u = this.visitTick(t);
          if (Ze(u))
            try {
              await u;
            } catch (n) {
              let i = t[t.length - 1].node;
              throw this.handleError(n, i);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [t, u] of this.listeners.OnceExit) {
          this.result.lastPlugin = t;
          try {
            if (e.type === "document") {
              let n = e.nodes.map(
                (i) => u(i, this.helpers)
              );
              await Promise.all(n);
            } else
              await u(e, this.helpers);
          } catch (n) {
            throw this.handleError(n);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (u) => e.Once(u, this.helpers)
          );
          return Ze(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = os;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let n = new is(t, this.result.root, this.result.opts).generate();
    return this.result.css = n[0], this.result.map = n[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Ze(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[fe]; )
        e[fe] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || ls(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [u, n] of e) {
      this.result.lastPlugin = u;
      let i;
      try {
        i = n(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Ze(i))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: u, visitors: n } = t;
    if (u.type !== "root" && u.type !== "document" && !u.parent) {
      e.pop();
      return;
    }
    if (n.length > 0 && t.visitorIndex < n.length) {
      let [o, l] = n[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === n.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return l(u.toProxy(), this.helpers);
      } catch (a) {
        throw this.handleError(a, u);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, l;
      for (; l = u.nodes[u.indexes[o]]; )
        if (u.indexes[o] += 1, !l[fe]) {
          l[fe] = !0, e.push(Dr(l));
          return;
        }
      t.iterator = 0, delete u.indexes[o];
    }
    let i = t.events;
    for (; t.eventIndex < i.length; ) {
      let o = i[t.eventIndex];
      if (t.eventIndex += 1, o === Fe) {
        u.nodes && u.nodes.length && (u[fe] = !0, t.iterator = u.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[fe] = !0;
    let t = Fn(e);
    for (let u of t)
      if (u === Fe)
        e.nodes && e.each((n) => {
          n[fe] || this.walkSync(n);
        });
      else {
        let n = this.listeners[u];
        if (n && this.visitSync(n, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
};
He.registerPostcss = (r) => {
  Su = r;
};
var Vn = He;
He.default = He;
ss.registerLazyResult(He);
ns.registerLazyResult(He);
let ps = Bn, bs = Fu;
const ms = Hu;
let gs = Ft, ys = Un, Tu = class {
  constructor(e, t, u) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = u, this._map = void 0;
    let n, i = gs;
    this.result = new ms(this._processor, n, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let l = new ps(i, n, this._opts, t);
    if (l.isMap()) {
      let [a, f] = l.generate();
      a && (this.result.css = a), f && (this.result.map = f);
    } else
      l.clearAnnotation(), this.result.css = l.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || ys(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = bs;
    try {
      e = t(this._css, this._opts);
    } catch (u) {
      this.error = u;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
};
var xs = Tu;
Tu.default = Tu;
let vs = $u, ws = Vn, Es = xs, Ss = dt, it = class {
  constructor(e = []) {
    this.version = "8.5.1", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let u of e)
      if (u.postcss === !0 ? u = u() : u.postcss && (u = u.postcss), typeof u == "object" && Array.isArray(u.plugins))
        t = t.concat(u.plugins);
      else if (typeof u == "object" && u.postcssPlugin)
        t.push(u);
      else if (typeof u == "function")
        t.push(u);
      else if (typeof u == "object" && (u.parse || u.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(u + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Es(this, e, t) : new ws(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var Ts = it;
it.default = it;
Ss.registerProcessor(it);
vs.registerProcessor(it);
let zn = Bu, Gn = Vt, As = Ie, _s = ku, Wn = zt, Yn = $u, Os = N0, Ns = Gt, Cs = Vn, Is = Dn, Ps = Ht, Rs = Fu, Vu = Ts, Ds = Hu, Xn = dt, Jn = Uu, Ls = Ft, Ms = $n;
function z(...r) {
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new Vu(r);
}
z.plugin = function(e, t) {
  let u = !1;
  function n(...o) {
    console && console.warn && !u && (u = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let l = t(...o);
    return l.postcssPlugin = e, l.postcssVersion = new Vu().version, l;
  }
  let i;
  return Object.defineProperty(n, "postcss", {
    get() {
      return i || (i = n()), i;
    }
  }), n.process = function(o, l, a) {
    return z([n(a)]).process(o, l);
  }, n;
};
z.stringify = Ls;
z.parse = Rs;
z.fromJSON = Os;
z.list = Is;
z.comment = (r) => new Gn(r);
z.atRule = (r) => new zn(r);
z.decl = (r) => new Wn(r);
z.rule = (r) => new Jn(r);
z.root = (r) => new Xn(r);
z.document = (r) => new Yn(r);
z.CssSyntaxError = _s;
z.Declaration = Wn;
z.Container = As;
z.Processor = Vu;
z.Document = Yn;
z.Comment = Gn;
z.Warning = Ms;
z.AtRule = zn;
z.Result = Ds;
z.Input = Ns;
z.Rule = Jn;
z.Root = Xn;
z.Node = Ps;
Cs.registerPostcss(z);
var ks = z;
z.default = z;
const js = Br, Lr = Pa, { isPlainObject: qs } = Lu, Mr = Ga, Bs = Wa, { parse: $s } = ks, Us = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], Fs = ["script", "style"];
function je(r, e) {
  r && Object.keys(r).forEach(function(t) {
    e(r[t], t);
  });
}
function ge(r, e) {
  return {}.hasOwnProperty.call(r, e);
}
function kr(r, e) {
  const t = [];
  return je(r, function(u) {
    e(u) && t.push(u);
  }), t;
}
function Hs(r) {
  for (const e in r)
    if (ge(r, e))
      return !1;
  return !0;
}
function Vs(r) {
  return r.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
var zs = at;
const Gs = /^[^\0\t\n\f\r /<=>]+$/;
function at(r, e, t) {
  if (r == null)
    return "";
  typeof r == "number" && (r = r.toString());
  let u = "", n = "";
  function i(p, x) {
    const g = this;
    this.tag = p, this.attribs = x || {}, this.tagPosition = u.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
      if (m.length) {
        const C = m[m.length - 1];
        C.text += g.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      m.length && Us.includes(this.tag) && m[m.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, at.defaults, e), e.parser = Object.assign({}, Ws, e.parser);
  const o = function(p) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf(p) > -1;
  };
  Fs.forEach(function(p) {
    o(p) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${p}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const l = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let a, f;
  e.allowedAttributes && (a = {}, f = {}, je(e.allowedAttributes, function(p, x) {
    a[x] = [];
    const g = [];
    p.forEach(function(C) {
      typeof C == "string" && C.indexOf("*") >= 0 ? g.push(Lr(C).replace(/\\\*/g, ".*")) : a[x].push(C);
    }), g.length && (f[x] = new RegExp("^(" + g.join("|") + ")$"));
  }));
  const h = {}, y = {}, s = {};
  je(e.allowedClasses, function(p, x) {
    if (a && (ge(a, x) || (a[x] = []), a[x].push("class")), h[x] = p, Array.isArray(p)) {
      const g = [];
      h[x] = [], s[x] = [], p.forEach(function(C) {
        typeof C == "string" && C.indexOf("*") >= 0 ? g.push(Lr(C).replace(/\\\*/g, ".*")) : C instanceof RegExp ? s[x].push(C) : h[x].push(C);
      }), g.length && (y[x] = new RegExp("^(" + g.join("|") + ")$"));
    }
  });
  const c = {};
  let E;
  je(e.transformTags, function(p, x) {
    let g;
    typeof p == "function" ? g = p : typeof p == "string" && (g = at.simpleTransform(p)), x === "*" ? E = g : c[x] = g;
  });
  let _, m, T, P, N, R, F = !1;
  Q();
  const K = new js.Parser({
    onopentag: function(p, x) {
      if (e.onOpenTag && e.onOpenTag(p, x), e.enforceHtmlBoundary && p === "html" && Q(), N) {
        R++;
        return;
      }
      const g = new i(p, x);
      m.push(g);
      let C = !1;
      const G = !!g.text;
      let J;
      if (ge(c, p) && (J = c[p](p, x), g.attribs = x = J.attribs, J.text !== void 0 && (g.innerText = J.text), p !== J.tagName && (g.name = p = J.tagName, P[_] = J.tagName)), E && (J = E(p, x), g.attribs = x = J.attribs, p !== J.tagName && (g.name = p = J.tagName, P[_] = J.tagName)), (!o(p) || e.disallowedTagsMode === "recursiveEscape" && !Hs(T) || e.nestingLimit != null && _ >= e.nestingLimit) && (C = !0, T[_] = !0, (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && l.indexOf(p) !== -1 && (N = !0, R = 1)), _++, C) {
        if (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          if (g.innerText && !G) {
            const V = k(g.innerText);
            e.textFilter ? u += e.textFilter(V, p) : u += V, F = !0;
          }
          return;
        }
        n = u, u = "";
      }
      u += "<" + p, p === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (g.innerText = ""), C && (e.disallowedTagsMode === "escape" || e.disallowedTagsMode === "recursiveEscape") && e.preserveEscapedAttributes ? je(x, function(V, H) {
        u += " " + H + '="' + k(V || "", !0) + '"';
      }) : (!a || ge(a, p) || a["*"]) && je(x, function(V, H) {
        if (!Gs.test(H)) {
          delete g.attribs[H];
          return;
        }
        if (V === "" && !e.allowedEmptyAttributes.includes(H) && (e.nonBooleanAttributes.includes(H) || e.nonBooleanAttributes.includes("*"))) {
          delete g.attribs[H];
          return;
        }
        let Ge = !1;
        if (!a || ge(a, p) && a[p].indexOf(H) !== -1 || a["*"] && a["*"].indexOf(H) !== -1 || ge(f, p) && f[p].test(H) || f["*"] && f["*"].test(H))
          Ge = !0;
        else if (a && a[p]) {
          for (const B of a[p])
            if (qs(B) && B.name && B.name === H) {
              Ge = !0;
              let $ = "";
              if (B.multiple === !0) {
                const oe = V.split(" ");
                for (const se of oe)
                  B.values.indexOf(se) !== -1 && ($ === "" ? $ = se : $ += " " + se);
              } else B.values.indexOf(V) >= 0 && ($ = V);
              V = $;
            }
        }
        if (Ge) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(H) !== -1 && ue(p, V)) {
            delete g.attribs[H];
            return;
          }
          if (p === "script" && H === "src") {
            let B = !0;
            try {
              const $ = Z(V);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const oe = (e.allowedScriptHostnames || []).find(function(re) {
                  return re === $.url.hostname;
                }), se = (e.allowedScriptDomains || []).find(function(re) {
                  return $.url.hostname === re || $.url.hostname.endsWith(`.${re}`);
                });
                B = oe || se;
              }
            } catch {
              B = !1;
            }
            if (!B) {
              delete g.attribs[H];
              return;
            }
          }
          if (p === "iframe" && H === "src") {
            let B = !0;
            try {
              const $ = Z(V);
              if ($.isRelativeUrl)
                B = ge(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const oe = (e.allowedIframeHostnames || []).find(function(re) {
                  return re === $.url.hostname;
                }), se = (e.allowedIframeDomains || []).find(function(re) {
                  return $.url.hostname === re || $.url.hostname.endsWith(`.${re}`);
                });
                B = oe || se;
              }
            } catch {
              B = !1;
            }
            if (!B) {
              delete g.attribs[H];
              return;
            }
          }
          if (H === "srcset")
            try {
              let B = Bs(V);
              if (B.forEach(function($) {
                ue("srcset", $.url) && ($.evil = !0);
              }), B = kr(B, function($) {
                return !$.evil;
              }), B.length)
                V = Vs(kr(B, function($) {
                  return !$.evil;
                })), g.attribs[H] = V;
              else {
                delete g.attribs[H];
                return;
              }
            } catch {
              delete g.attribs[H];
              return;
            }
          if (H === "class") {
            const B = h[p], $ = h["*"], oe = y[p], se = s[p], re = s["*"], Yt = y["*"], We = [
              oe,
              Yt
            ].concat(se, re).filter(function(ht) {
              return ht;
            });
            if (B && $ ? V = I(V, Mr(B, $), We) : V = I(V, B || $, We), !V.length) {
              delete g.attribs[H];
              return;
            }
          }
          if (H === "style") {
            if (e.parseStyleAttributes)
              try {
                const B = $s(p + " {" + V + "}", { map: !1 }), $ = b(B, e.allowedStyles);
                if (V = w($), V.length === 0) {
                  delete g.attribs[H];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + p + " {" + V + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete g.attribs[H];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          u += " " + H, V && V.length ? u += '="' + k(V, !0) + '"' : e.allowedEmptyAttributes.includes(H) && (u += '=""');
        } else
          delete g.attribs[H];
      }), e.selfClosing.indexOf(p) !== -1 ? u += " />" : (u += ">", g.innerText && !G && !e.textFilter && (u += k(g.innerText), F = !0)), C && (u = n + k(u), n = ""), g.openingTagLength = u.length - g.tagPosition;
    },
    ontext: function(p) {
      if (N)
        return;
      const x = m[m.length - 1];
      let g;
      if (x && (g = x.tag, p = x.innerText !== void 0 ? x.innerText : p), e.disallowedTagsMode === "completelyDiscard" && !o(g))
        p = "";
      else if ((e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && (g === "script" || g === "style"))
        u += p;
      else if (!F) {
        const C = k(p, !1);
        e.textFilter ? u += e.textFilter(C, g) : u += C;
      }
      if (m.length) {
        const C = m[m.length - 1];
        C.text += p;
      }
    },
    onclosetag: function(p, x) {
      if (e.onCloseTag && e.onCloseTag(p, x), N)
        if (R--, !R)
          N = !1;
        else
          return;
      const g = m.pop();
      if (!g)
        return;
      if (g.tag !== p) {
        m.push(g);
        return;
      }
      N = e.enforceHtmlBoundary ? p === "html" : !1, _--;
      const C = T[_];
      if (C) {
        if (delete T[_], e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          g.updateParentNodeText();
          return;
        }
        n = u, u = "";
      }
      if (P[_] && (p = P[_], delete P[_]), e.exclusiveFilter) {
        const G = e.exclusiveFilter(g);
        if (G === "excludeTag") {
          C && (u = n, n = ""), u = u.substring(0, g.tagPosition) + u.substring(g.tagPosition + g.openingTagLength);
          return;
        } else if (G) {
          u = u.substring(0, g.tagPosition);
          return;
        }
      }
      if (g.updateParentNodeMediaChildren(), g.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf(p) !== -1 || // Escaped tag, closing tag is implied
      x && !o(p) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        C && (u = n, n = "");
        return;
      }
      u += "</" + p + ">", C && (u = n + k(u), n = ""), F = !1;
    }
  }, e.parser);
  return K.write(r), K.end(), u;
  function Q() {
    u = "", _ = 0, m = [], T = {}, P = {}, N = !1, R = 0;
  }
  function k(p, x) {
    return typeof p != "string" && (p = p + ""), e.parser.decodeEntities && (p = p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), x && (p = p.replace(/"/g, "&quot;"))), p = p.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), x && (p = p.replace(/"/g, "&quot;")), p;
  }
  function ue(p, x) {
    for (x = x.replace(/[\x00-\x20]+/g, ""); ; ) {
      const G = x.indexOf("<!--");
      if (G === -1)
        break;
      const J = x.indexOf("-->", G + 4);
      if (J === -1)
        break;
      x = x.substring(0, G) + x.substring(J + 3);
    }
    const g = x.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!g)
      return x.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : !1;
    const C = g[1].toLowerCase();
    return ge(e.allowedSchemesByTag, p) ? e.allowedSchemesByTag[p].indexOf(C) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(C) === -1;
  }
  function Z(p) {
    if (p = p.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), p.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let x = "relative://relative-site";
    for (let G = 0; G < 100; G++)
      x += `/${G}`;
    const g = new URL(p, x);
    return {
      isRelativeUrl: g && g.hostname === "relative-site" && g.protocol === "relative:",
      url: g
    };
  }
  function b(p, x) {
    if (!x)
      return p;
    const g = p.nodes[0];
    let C;
    return x[g.selector] && x["*"] ? C = Mr(
      x[g.selector],
      x["*"]
    ) : C = x[g.selector] || x["*"], C && (p.nodes[0].nodes = g.nodes.reduce(S(C), [])), p;
  }
  function w(p) {
    return p.nodes[0].nodes.reduce(function(x, g) {
      return x.push(
        `${g.prop}:${g.value}${g.important ? " !important" : ""}`
      ), x;
    }, []).join(";");
  }
  function S(p) {
    return function(x, g) {
      return ge(p, g.prop) && p[g.prop].some(function(G) {
        return G.test(g.value);
      }) && x.push(g), x;
    };
  }
  function I(p, x, g) {
    return x ? (p = p.split(/\s+/), p.filter(function(C) {
      return x.indexOf(C) !== -1 || g.some(function(G) {
        return G.test(C);
      });
    }).join(" ")) : p;
  }
}
const Ws = {
  decodeEntities: !0
};
at.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "menu",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0,
  preserveEscapedAttributes: !1
};
at.simpleTransform = function(r, e, t) {
  return t = t === void 0 ? !0 : t, e = e || {}, function(u, n) {
    let i;
    if (t)
      for (i in e)
        n[i] = e[i];
    else
      n = e;
    return {
      tagName: r,
      attribs: n
    };
  };
};
const Ys = /* @__PURE__ */ vi(zs), qt = ({ value: r, as: e = "span", ...t }) => {
  const u = e, n = xi(() => r ? Ys(r) : "", [r]);
  return /* @__PURE__ */ A.jsx(u, { dangerouslySetInnerHTML: { __html: n }, ...t });
}, Zn = ({ cents: r, locale: e, showCents: t = !1 }) => new Intl.NumberFormat(e, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: t ? 2 : 0,
  maximumFractionDigits: t ? 2 : 0
}).format(r / 100), Lo = ({
  project: r,
  locale: e = document.documentElement.lang || "de",
  href: t,
  onClick: u,
  className: n,
  showDescription: i,
  openInTab: o,
  bottomContent: l,
  children: a,
  showCarrierName: f
}) => {
  var P, N, R, F, K, Q, k, ue;
  const h = Zn({ cents: r.open_amount_in_cents, locale: e }), y = new Intl.NumberFormat(e).format(r.donations_count), s = e === "de" ? "fehlen noch" : "still needed", c = e === "de" ? "Spenden" : "donations", E = t || ((P = r.links.find((Z) => Z.rel === "platform")) == null ? void 0 : P.href), _ = (R = (N = r.profile_picture) == null ? void 0 : N.links.find((Z) => Z.rel === "fill_410x214")) == null ? void 0 : R.href, m = (Q = (K = (F = r.carrier) == null ? void 0 : F.picture) == null ? void 0 : K.links.find((Z) => Z.rel === "fill_100x100")) == null ? void 0 : Q.href, T = (Z) => {
    u && u(Z, r);
  };
  return /* @__PURE__ */ A.jsxs(
    "a",
    {
      title: r.title,
      onClick: T,
      className: `donatable-teaser ${n ?? ""} ${i ? "donatable-teaser--with-description" : ""} ${l ? "donatable-teaser--with-bottom-content" : ""}`,
      href: E,
      target: o ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        a,
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${_})` },
            title: r.title
          }
        ),
        /* @__PURE__ */ A.jsx(qt, { as: "h2", className: "donatable-teaser--title", value: r.title }),
        i && /* @__PURE__ */ A.jsx(qt, { className: "donatable-teaser--description", as: "div", value: r.description }),
        /* @__PURE__ */ A.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ A.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ A.jsxs("div", { children: [
              r.city && /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
                /* @__PURE__ */ A.jsx("span", { children: r.city }),
                ",",
                " "
              ] }),
              r.country
            ] }),
            /* @__PURE__ */ A.jsx("div", { children: f ? /* @__PURE__ */ A.jsx("span", { children: (k = r.carrier) == null ? void 0 : k.name }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
              /* @__PURE__ */ A.jsx("span", { children: y }),
              " ",
              c
            ] }) }),
            /* @__PURE__ */ A.jsxs("div", { children: [
              /* @__PURE__ */ A.jsx("span", { children: h }),
              " ",
              s
            ] })
          ] }),
          /* @__PURE__ */ A.jsx("img", { src: m, alt: (ue = r.carrier) == null ? void 0 : ue.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ A.jsx("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ A.jsx("div", { className: "donatable-teaser--progress-bar", style: { width: `${r.progress_percentage}%` } }) }),
        l
      ]
    }
  );
}, Xs = (r, e) => e === 1 ? r === "de" ? "Spende" : "donation" : r === "de" ? "Spenden" : "donations", Mo = ({
  fundraisingEvent: r,
  locale: e = document.documentElement.lang || "de",
  href: t,
  onClick: u,
  openInTab: n,
  children: i
}) => {
  var s, c, E, _, m, T, P, N;
  const o = t || ((s = r.links.find((R) => R.rel === "platform")) == null ? void 0 : s.href), l = (E = (c = r.profile_picture) == null ? void 0 : c.links.find(
    (R) => R.rel === "fill_410x214"
  )) == null ? void 0 : E.href, a = Zn({ cents: r.donated_amount_in_cents, locale: e }), f = (T = (m = (_ = r.contact) == null ? void 0 : _.picture) == null ? void 0 : m.links.find((R) => R.rel === "fill_100x100")) == null ? void 0 : T.href, h = (R) => {
    u && u(R, r);
  }, y = Xs(e, r.donations_count);
  return /* @__PURE__ */ A.jsxs(
    "a",
    {
      title: r.title,
      onClick: h,
      className: "donatable-teaser",
      href: o,
      target: n ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        i,
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${l})` },
            title: r.title
          }
        ),
        /* @__PURE__ */ A.jsx(qt, { as: "h2", className: "donatable-teaser--title", value: r.title }),
        /* @__PURE__ */ A.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ A.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx(qt, { as: "span", value: (P = r.contact) == null ? void 0 : P.name }) }),
            /* @__PURE__ */ A.jsxs("div", { children: [
              /* @__PURE__ */ A.jsx("span", { children: r.donations_count }),
              " ",
              y
            ] }),
            /* @__PURE__ */ A.jsxs("div", { children: [
              /* @__PURE__ */ A.jsx("span", { children: a }),
              " ",
              e === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ A.jsx(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: f,
              alt: ((N = r.contact) == null ? void 0 : N.name) ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, Js = ({
  icon: r,
  content: e,
  className: t = "",
  boxShadow: u,
  buttonClassName: n = "",
  ...i
}) => {
  const o = r;
  return /* @__PURE__ */ A.jsxs(
    "a",
    {
      ...i,
      className: `share-button--full ${u ? "share-button--box-shadowed" : ""} ${n} ${t}`,
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ A.jsx(o, { className: "share-button--icon" }) }),
        /* @__PURE__ */ A.jsx("span", { className: "share-button--text", children: e })
      ]
    }
  );
}, Zs = ({
  icon: r,
  content: e,
  className: t = "",
  buttonClassName: u = "",
  boxShadow: n,
  ...i
}) => {
  const o = r;
  return /* @__PURE__ */ A.jsxs("a", { ...i, className: `share-button--minimal ${u} ${t}`, children: [
    /* @__PURE__ */ A.jsx(o, { className: "share-button--icon" }),
    /* @__PURE__ */ A.jsx("span", { className: "share-button--text", children: e })
  ] });
}, Qs = ({ icon: r, className: e = "", boxShadow: t, buttonClassName: u = "", ...n }) => {
  const i = r;
  return /* @__PURE__ */ A.jsx(
    "a",
    {
      ...n,
      className: `share-button--round ${t ? "share-button--box-shadowed" : ""} ${u} ${e}`,
      children: /* @__PURE__ */ A.jsx(i, {})
    }
  );
}, Ks = ({
  icon: r,
  className: e = "",
  buttonClassName: t = "",
  boxShadow: u,
  ...n
}) => {
  const i = r;
  return /* @__PURE__ */ A.jsx("a", { ...n, className: `share-button--square ${t} ${e}`, children: /* @__PURE__ */ A.jsx(i, {}) });
}, eo = ({
  icon: r,
  content: e,
  className: t = "",
  boxShadow: u,
  buttonClassName: n = "",
  ...i
}) => {
  const o = r;
  return /* @__PURE__ */ A.jsxs("div", { className: `share-button--round-with-label ${t}`, children: [
    /* @__PURE__ */ A.jsx(
      "a",
      {
        ...i,
        className: `share-button--round ${u ? "share-button--box-shadowed" : ""} ${n}`,
        children: /* @__PURE__ */ A.jsx(o, {})
      }
    ),
    e
  ] });
}, to = {
  full: Js,
  minimal: Zs,
  round: Qs,
  square: Ks,
  roundWithLabel: eo
}, Pe = ({
  action: r,
  ariaLabel: e,
  buttonLabel: t,
  className: u,
  icon: n
}) => (o) => {
  const l = to[o.shape], a = (f) => {
    f.preventDefault(), o.beforeOnClick && o.beforeOnClick(f), r(o);
  };
  return /* @__PURE__ */ A.jsx(
    l,
    {
      "aria-label": e,
      boxShadow: o.boxShadow,
      className: o.className || "",
      buttonClassName: u,
      href: "#",
      onClick: a,
      role: "button",
      title: o.title || "",
      label: t || e,
      icon: n,
      content: o.content
    }
  );
}, uo = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), ro = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), no = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), io = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), ao = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), so = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ A.jsxs("g", { children: [
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), oo = ({ size: r = "60%" }) => /* @__PURE__ */ A.jsxs(
  "svg",
  {
    className: "share-button--icon",
    width: r,
    height: r,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
), zu = (r) => {
  const e = Object.keys(r).map((t) => r[t] ? encodeURIComponent(t) + "=" + encodeURIComponent(r[t]) : null).filter((t) => t).join("&");
  return e ? `?${e}` : "";
}, Ve = (r, e) => encodeURIComponent(r + zu(e || {})), Qn = (r) => window.open(r, "sharer", "toolbar=no,width=1042,height=436"), Kn = (r) => {
  const e = document.createElement("textarea");
  e.value = r, document.body.appendChild(e), e.select();
  const t = document.execCommand("copy");
  if (document.body.removeChild(e), !t) {
    const n = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(n);
  }
  return t;
}, ei = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), co = ({
  shareUrl: r,
  subject: e = null,
  teaser: t = "",
  utmParams: u
}) => {
  const n = encodeURIComponent(e || t), i = Ve(`${t} ${r}`, u);
  return window.open(`mailto:?subject=${n}&body=${i}`, "_self");
}, ko = Pe({
  action: co,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: uo
}), lo = ({ shareUrl: r, utmParams: e }) => Qn(`https://www.facebook.com/sharer/sharer.php?u=${Ve(r, e)}`), jo = Pe({
  action: lo,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: ro
}), fo = ({
  facebookAppId: r,
  shareUrl: e,
  utmParams: t
}) => ei() ? window.open(`fb-messenger://share?link=${Ve(e, t)}&app_id=${r}`) : Qn(
  `http://www.facebook.com/dialog/send?app_id=${r}&link=${Ve(
    e,
    t
  )}&redirect_uri=${encodeURIComponent(e)}`
), qo = Pe({
  action: fo,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: no
}), ho = ({ shareUrl: r, teaser: e = "", utmParams: t }) => window.open(
  `https://telegram.me/share/url?url=${Ve(r, t)}&text=${encodeURIComponent(e)}`
), Bo = Pe({
  action: ho,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: io
}), po = ({ shareUrl: r, teaser: e, utmParams: t }) => window.open(
  `https://${ei() ? "api" : "web"}.whatsapp.com/send?text=${Ve(
    `${e ? e + " " : ""}${r}`,
    t
  )}`
), $o = Pe({
  action: po,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: ao
}), bo = ({ shareUrl: r, utmParams: e }) => {
  Kn(`${r}${zu(e || {})}`);
}, Uo = Pe({
  action: bo,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: so
}), mo = ({ shareUrl: r, utmParams: e }) => {
  Kn(`${r}${zu(e || {})}`);
}, Fo = Pe({
  action: mo,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: oo
}), Ho = (r, e) => r.replace(
  /\w\w/g,
  (t) => ("0" + Math.min(255, Math.max(0, parseInt(t, 16) + e)).toString(16)).substr(-2)
);
export {
  ko as EmailButton,
  jo as FacebookButton,
  qo as FacebookMessengerButton,
  Mo as FundraisingEventTeaser,
  Fo as InstagramButton,
  Uo as LinkButton,
  Lo as ProjectTeaser,
  Bo as TelegramButton,
  $o as WhatsappButton,
  Ho as changeBrightness,
  co as emailShareAction,
  Ve as encodedShareURL,
  fo as facebookMessengerShareAction,
  lo as facebookShareAction,
  Zn as formatAmount,
  mo as instagramAction,
  bo as linkAction,
  Qn as openPopup,
  ho as telegramShareAction,
  po as whatsappShareAction
};
